// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Baloo+Thambi+2:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --font-family: 'Baloo Thambi 2', cursive;
  --border-radius:  .25rem;
  --border: 1px solid #ccc;
  --orange: #FE7021;
  --yellow: #F5C400;
  --blue: #4221E5;
  --newOrange: #FFAD31;
  --newMainBlue: #2665F2;
  --newMainBlueHover: #1F53C9;
  --newLightBlue: #E8EDFB;
  --newOrangeHover: #E69528; 
  /* --headingblue: #171F46; */
  --darkblue: #151935;
  --color:  #7E858E;
  --line-height: 1.35;
  --box-shadow: 0 0 5px 0 #3333;
  --gradientclr: linear-gradient(93.59deg, #FF7020 -0.51%, #F5C400 105.82%);
}
/*==== Basic Css ====*/
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#root{
    /* height: 100vh; */
  }

  body::-webkit-scrollbar {
    width: 5px;
    border-radius: 10px;
  }
  
  /* Track */
  body::-webkit-scrollbar-track {
    background: #65B5FF;
    border-radius: 10px;
  }
  
  /* Handle */
  body::-webkit-scrollbar-thumb {
    background: #2665F2;
    border-radius: 10px;
  }
  
  /* Handle on hover */
  body::-webkit-scrollbar-thumb:hover {
    background: #2665F2;
    border-radius: 10px;
  } 


a, a:hover{
  text-decoration: none!important;
}

h1,h2,h3,h4,h5,h6{
  margin: 0;
}
p{
  margin: 0;
}
ol li, ul li{
  margin: 0;
  padding: 0;
}
body {
    font-family: var(--font-family);
    line-height: var(--line-height);
    color: var(--color);
    font-weight: 400;
    width: 100%;
    overflow-x: clip;
}

/*==== custom utility classes ====*/
.btn {
    box-shadow: none !important;
    font-family: var(--font-family) ;
}
.onboard-footer .btn-main {
   background-color: var(--blue); 
}
.btn-main{
  /* background-color: var(--blue); */
  border-color: var(--blue);
  color: #FFF;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
}
.add_button_New{
    background-color: var(--blue);
  border-color: var(--blue);
  color: #FFF;
  padding: 0px 20px;
  border-radius: 999px;
  font-weight: 500;
  font-family: var(--font-family) ;
  /* margin-left: 19px; */
  font-size: 11px;
  line-height: 29px;
  /* width: 88%; */
}
@media screen and (max-width: 1440px) and (min-width: 1024px) {
    .add_button_New{
  padding: 0px 16px;

    }
}
/* .reposnsive_margin{
    position: relative;
  top: 11px;
} */
.btn-main:hover, .btn-main:focus, .btn-main:active{
  background-color: var(--blue);
  border-color: var(--blue);
  color: #FFF;
}
.text-main{
  color: var(--newMainBlue)!important;
}
.text-dark{
  color: var(--darkblue);
}
.text-yellow{
  color:rgb(245, 196, 0);
}
.editPimage img {
    width: 200px;
    height: 200px;
    object-fit: fill;
    border-radius: .5rem;
    object-position: center;
}
.bg-main{
  background-color: var(--blue);
}
.chekout-middle-table {
    max-height: 100px;
    overflow-y: auto;
}

.btn-sub{
  background-color: var(--darkblue);
  border-color: var(--darkblue);
}
.text-sub{
  color: var(--darkblue);
}
.bg-sub{
  background-color: var(--darkblue);
}
.box-shadow{
  box-shadow: var(--box-shadow);
}
.border{
  border: var(--border);
}
/*==== favorite brand classes ====*/

.brand-block {
    width: auto;
    /* max-width: 112px; */
    height: 150px;
    /* background: #FFFFFF; */
    /* border: 2px solid #D7DFE9; */
    border-radius: 14px;
    /* padding-bottom: 32px; */
    position: relative;
    display: block;
    text-decoration: none;
}
.brand-image {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.brand-footer {
    background: #F5C40080;
    border-radius: 0px 0px 4px 4px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #171F46;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
.slider-area{
  position: relative;
  padding: 0px 80px;
}

.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after {
    content: "\\f054";
    font-family: 'Font Awesome 5 Pro';
    color: var(--darkblue);
}

.swiper-button-prev::after, .swiper-rtl .swiper-button-next::after {
    content: "\\f053";
    font-family: 'Font Awesome 5 Pro';
    color: var(--darkblue);
}
.brand-block:hover { border: 2px solid #FF7020; border-radius: 10px 10px 10px
 10px; transition: all ease 0.5s; }
.section-header {
    font-weight: 700;
    font-size: max(36px, 2vw);
    line-height: 1.25;
    color: var(--darkblue);
}
.section-headers {
    font-weight: 600;
    font-size: max(20px, 1.2vw);
    line-height: 1;
    color: var(--darkblue);
}
.view-all{
  min-width: 170px;
}

/*==== help need classes ====*/

.charities-block ul li {
    list-style: none;
    margin-right: 40px;
}

.charities-block ul li:last-child{
  margin-right: 0px;
}

.charities-block ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    margin-top: 20px;
}

/*==== Reedem all classes ====*/

.bg-light {
    background: #E8EDFB!important;
}

.product-block img:hover {
    transform: scale(1.135);
    transition: all ease 0.35s;
}

.product-block img {
    transform: scale(1);
    transition: all ease 0.35s;
}
.product-block {
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: column;
    align-items: center;
    /* min-width: 200px; */
}
.product-block span {
    display: flex;
    margin-top: 25px;
    justify-content: center;
    padding: 5px 10px;
    background: #fff;
    border-radius: 999px;
    width: 100%;
    text-align: center;
    color: #333;
    font-weight: 600;
    border: 1px solid #ccc;
    transition: all ease 0.3s;
}

.product-block:hover span{
    transition: all ease 0.3s;
    background:rgb(61, 5, 182);
    border: 1px solid var(--darkblue);
    color: #fff;
}

/* .custom-gap {
    padding: 0px 7%;
} */
.delight-header p {
    font-size: max(18px, 1vw);
}
.delight-img img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
}
.delight-img {
  position: relative;
  height: 200px;
  overflow: hidden;
}
.delight-card {
    background: #fff;
    box-shadow: 0px 0px 5px 0px #3333;
    margin: 25px 0;
    filter: drop-shadow(0px 8px 40px rgba(23, 31, 70, 0.08));
    border-radius: .5rem;
    overflow: hidden;
    display: block;
    transition: all ease 0.25s;
}
/* .delight-card:hover{
    transform: translateY(70px);
    transition: all ease 0.25s;
} */
.delight-logos {
    min-height: 109px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 25px;
}
.delight-logos p {
    font-weight: 500;
    font-size: max(18px, 1vw);
    line-height: 1.3;
    color: var(--darkblue);
    margin-bottom: 15px;
}
.mt-50{
    margin-top: 70px;
}
/* .delight-card.mt-50:hover{
    transform: translateY(  0px);
    transition: all ease 0.25s;
} */

.delight-card:hover .delight-img img {
    transform: scale(1.025);
    transition: all ease 0.25s;
}

.delight-img img {
    transform: scale(1);
    transition: all ease 0.25s;
}

.delight-slider .swiper-slide:nth-child(odd) {
    margin-top: 70px;
}

/*==== footer classes ====*/
.footer {
    border-top: 1px solid #cccc;
}
.powerd-by {
    /* display: flex; */
    /* align-items: center; */
}
.powerd-by span {
    /* margin-right: 10px; */
    font-size: 16px;
    font-weight: 400;
}
.footer-menu {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
}
.footer-menu li::after {
    content: "|";
    padding: 0 10px;
}
.footer-menu li {
    list-style: none;
}
.footer-menu li:last-child::after {
    display: none;
}
.footer-menu li a {
    color: var(--darkblue);
    text-transform: uppercase;
}

/*==== onboard modal classes ====*/
.onboard-modal .btn-close {
    position: absolute;
    top: 15px;
    right: 15px;
}
.welcome-note {
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
    color: var(--darkblue);
}
.welcome-para {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: var(--darkblue);
}
.welcome-para span{
    color: #FF7020;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
}
.onboard-modal .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: auto;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 0.5rem;
    outline: 0;
}
.onboard-modal button, .onboard-modal a{
    box-shadow: none!important;
}
.rdeem-progress {
    width: 100%;
    background: #ccc;
    position: relative;
    border-radius: 100px;
    margin: 40px 0px;
    display: flex;
    align-items: center;
    /* overflow: hidden; */
    height: 8px;
}
.progress-left {
    background: var(--orange);
    height: 100%;
    border-radius: 100px 0  0 100px;
    position: relative;
}
.progress-left span {
    position: absolute;
    top: -25px;
}
.progress-left span:first-child {
    left: 0;
}
.progress-left span:last-child {
    right: 0;
}
.progress-right {
    background: var(--blue);
    height: 8px;
    position: relative;
    border-radius: 0 100px 100px 0;
    margin-left: auto;
}
.progress-right span {
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    background: #ece9fc;
    font-size: 12px;
    width: max-content;
    padding: 5px;
    color: var(--blue);
    border-radius: 2px;
}
.progress-right span::after {
    content: "";
    width: 20px;
    height: 20px;
    background: #ece9fc;
    position: absolute;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    bottom: 0;
}

/*==== gift-card listing classes ====*/

.back-to-btn {
    color: #f1f1f1;
    transition: all ease 0.3s;
    position: absolute;
    top: 8px;
}
.back-to-btn:hover{
    color: #fff;
    transition: all ease 0.3s;
}
.custom-select {
    position: relative;
}
.select-label {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: -moz-fit-content;
    width: fit-content;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #7E858E;
}
.custom-select .form-select {
    height: 40px;
    /* border-radius: 2px; */
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #7E858E;
}
.custom-select .form-select:focus{
    box-shadow: none;
    border: 1px solid var(--blue);
}
/* .product-filters .search-bar {
    max-width: unset;
} */
.fw-semi{
    font-weight: 500!important;
}
.product-categories .product-block {
    margin-right: 15px;
}
.product-categories .product-block span {
    background: transparent;
    color: var(--darkblue);
    border: 1px solid #ccc;
}
.search-bar .form-control:focus {
    box-shadow: none;
    border-color: var(--blue);
}
.select2-container--default .select2-selection--single {
    height: 40px;
    padding-top: 5px;
    border: 1px solid #D7dfe9;
}
.select2-container--default.select2-container--open.select2-container--below .select2-selection--single, .select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {
    border: 1px solid var(--blue);
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 7px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b {
    border-width: 0px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b::after {
    content: "\\f078";
    font-family: 'font awesome 5 pro';
    position: absolute;
    transition: all ease 0.3s;
    font-size: 14px;
    color: var(--darkblue);
}
.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b::after {
    transform: rotate(180deg);
    transition: all ease 0.3s;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 0px;
    right: 10px;
}
.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
    border-width: 0;
}
.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable{
    background: #F5F7FA;
    color: var(--darkblue);
}
.select2-container--default .select2-results__option--selected{
    background: #F5F7FA;
    color: var(--darkblue);
    opacity: 0.85;
}
.category-btn.text-dark:hover {
    color: var(--blue) !important;
}
.select2-container--default .select2-search--dropdown .select2-search__field:focus {
    border-color: var(--blue);
    outline: none;
}
.select2-results__option {
    -webkit-user-select: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #7E858E;
}
.product-block.active span{
    background: var(--darkblue);
    color: #fff;
    border-color: var(--darkblue)!important;
}
.select2-container {
    width: 100% !important;
}


.listing-block {
    background: #FFFFFF;
    border: 1px solid #D7DFE9;
    border-radius: 16px;
    padding: 25px;
    height: 95%;
}
.listing-top-left {
    display: flex;
}
.listing-logo {
    width: 73px;
    height: 65px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    border: 1px solid #D7DFE9;
    border-radius: 5px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}
.listing-name {
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    color: var(--darkblue);
}
.listing-categorydtl {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #7E858E;
    margin-top: 5px;
}
.view-listing-btn {
    font-weight: 700;
    font-size: 11px;
    line-height: 16px;
    max-width: 130px;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: #7E858E;
    text-align: center;
}
.responsive_text{
  margin-top: 8px;
  font-size: 13px;
  font-weight: 500;
}
.listing-top {
    margin-bottom: 25px;
}
.listing-bottom-left {
    display: flex;
    flex-direction: column;
}

.listing-input {
    display: flex;
    align-items: center;
}
.listing-input-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #D9D9D9;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.listing-input-btn:hover {
    border: 1px solid #D9D9D9;
}
.listing-input-btn svg {
    height: 25px;
    width: 25px;
    transform: scale(1.5);
}
.inputwithunit {
    position: relative;
}
.inputwithunit span {
    position: absolute;
    left: 8px;
    font-weight: 700;
    font-size: 18px;
    line-height: 32px;
    text-align: center;
    color: #171F46;
    top: 50%;
    transform: translateY(-50%);
}
.inputwithunit .form-control {
    padding-left: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #171F46;
   width: 74px;
    padding-left: 20px;
}
.listing-bottom-right span {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    /* line-height: 8px; */
    color: var(--blue);
}
.listing-bottom-right{
    margin-left: 23px;
  
}
.listing-bottom-right h6 {
    font-weight: 700;
    font-size: 15px;
    line-height: 22px;
   
    color: var(--blue);
}
.listing-bottom-right h6 span{
    font-size: 24px!important;
    line-height: 32px;
}
.listing-bottom-right {
    text-align: center;
}
.listing-bottom-right h6 {
    margin: 5px auto;
    width: -moz-fit-content;
    width: fit-content;
}
.listing-logo img {
    max-width: 50px;
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
input[type=number] {
    -moz-appearance:textfield;
}


.checkout-left h5 {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
}
.checkout-left h5:nth-child(1) {
    color: var(--orange);
}
.checkut_Funds_used {
    color: var(--orange);
}
.checkout-left h5:nth-child(2) {
    color: var(--darkblue);
}
.checkout-Remaining{
    color: var(--darkblue);
}
.checkout-left h5:nth-child(3) {
    color: var(--blue);
}
.checkout_bonus {
    color: var(--blue);
}
.checkout_bonus_cash {
    color: var(--yellow);
}

.chekout-toggle {
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D7dfe9;
    border-radius: 100%;
    position: absolute;
    top: -20px;
    background: #fff;
    left: 50%;
    transform: translateX(-50%);
}
.new-chekout-toggle {
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D7dfe9;
    border-radius: 100%;
    position: absolute;
    top: 50%;
    left: -1%; /* Adjust the left positioning as needed */
    transform: translateX(-50%);
    background: #fff;
    z-index: 1; /* Ensure it's above other content */
}

.promotional_toggle{
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D7dfe9;
    border-radius: 100%;
    position: absolute;
    top: -24px;
    z-index: 1;
    background: #fff;
    left: 50%;
    transform: translate(-50%,-0%);  
}


.brands_toggle{
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D7dfe9;
    border-radius: 100%;
    /* position: absolute; */
    top: 80px;
    margin-top: 2px;
    margin-bottom: 2px;
    z-index: 2;
    background: #fff;
    right: 1%;
    transform: translate(-50%,-0%);  
}


.brands_toggle svg {
    transform: rotate(0deg);
    transition: all ease 0.5s;
}
.brands_toggle.rotate svg {
    transform: rotate(180deg);
    transition: all ease 0.5s;
}

.mobView-toggle{
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D7dfe9;
    border-radius: 100%;
    position: absolute;
    /* margin-top:10px; */
    background: #fff;
    left: 50%;
    transform: translateX(-50%);
}

.go-checkout {
    bottom: calc(0% - 85px);
    transition: all ease 1s;

}
.go-checkout-length-1 {
    bottom: calc(0% - 185px);
}

.go-checkout-length-2 {
    bottom: calc(0% - 200px);
}

.go-checkout-default {
    bottom: calc(0% - 150px);
}
.go-checkout.active {
    bottom: 0;
    transition: all ease 0.5s;
}
.go-checkout.notable{
    bottom: 0;
}
.chekout-toggle.rotate i, .chekout-toggle.rotate svg {
    transform: rotate(180deg);
    transition: all ease 0.5s;
}
.chekout-toggle i, .chekout-toggle svg {
    transform: rotate(0deg);
    transition: all ease 0.5s;
}


.promotional_toggle svg {
    transform: rotate(0deg);
    transition: all ease 0.5s;
}
.promotional_toggle.rotate svg {
    transform: rotate(180deg);
    transition: all ease 0.5s;
}
.mobView-toggle.rotate i, .mobView-toggle.rotate svg{
    transform: rotate(180deg);
    transition: all ease 0.5s;
}
.mobView-toggle i, .mobView-toggle svg {
    transform: rotate(0deg);
    transition: all ease 0.5s;
}
.hide_class{
opacity: 0;
transition: 0.9s;
display: none;

}
.product-listing {
    /* padding-bottom: 140px; */
}
.chekout-middle-table .table .btn {
    font-size: 12px;
}
.chekout-middle-table .table {
    font-size: 12px;
    color: #7E858E;
}
.chekout-middle-table .table thead tr th {
    font-weight: 400;
    color: var(--darkblue);
}
.table > :not(:last-child) > :last-child > * {
    border-bottom-width: 0px;
}
.table>:not(:first-child) {
    border-top-width: 0px;
}
/* .category-modal .category-block:hover {
    border: 1px solid var(--darkblue);
} */
.categories-mtitle {
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
    color: var(--darkblue);
}
.listing-block.highlight::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    /* background: #0000005e; */
    left: 0;
    top: 0;
    z-index: -1;
    background: #fff;
    border-radius: 10px;
}
.listing-block.highlight::after {
    content: "";
    width: 100%;
    height: 100%;
    position: fixed;
    background: #00000087;
    left: 0;
    top: 0;
    z-index: -2;
}
.listing-block.highlight {
    position: relative;
    z-index: 9999;
}

.onboard-step {
    position: absolute;
    margin-top: 15px;
    background: #fff;
    border-radius: 5px;
    padding: 20px 20px;
}
.onboard-step.step-1 {
    width: calc(100% + 227px);
    left: -75px;
    max-width: 600px;
    top: calc(100% + 10px);
}
.onboard-header h3 {
    color: var(--darkblue);
    font-weight: 600;
    font-size: max(20px, 1.5vw);
}
.onboard-close-btn {
    width: 30px;
    height: 30px;
    padding: 7px;
    background: #3333;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
.onboard-close-btn:hover{
    color: #333;
}
.onboard-middle p {
    line-height: 1.57;
}
.onboard-paginate span {
    width: 10px;
    height: 10px;
    background: #777;
    border-radius: 100%;
    margin: 0px 12px;
    /* cursor: pointer; */
}
.onboard-paginate span.active {
    background: var(--orange);
    /* cursor: not-allowed; */
}
.onboard-step.step-1::before {
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    top: 0px;
    transform: rotate(45deg) translateX(-50%);
    left: 50%;
    border-radius: 5px;
}
/* .onboard-step.step-2 {
    top: -130px;
    max-width: 500px;
    width: 428px;
    left: -716%;
    transform: translateX(-50%);
    box-shadow: 0px 0px 5px 0px #3333331c;
} */
.onboard-step.step-2 {
    top: 50%;
    width: 400px;
    right: calc(100% + 25px);
    box-shadow: 0px 0px 5px 0px #3333331c;
    transform: translateY(-50%);
}
/* .onboard-step.step-2::before {
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
    left: 99%;
    border-radius: 5px;
    bottom: 80px;
    box-shadow: 8px 0px 0px 0px #33333314;
} */
.onboard-step.step-2::before {
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    transform: rotate(45deg)translateY(-50%);
    left: calc(100% - 27px);
    border-radius: 5px;
    box-shadow: 8px 0px 0px 0px #33333314;
    top: calc(50% - 17px);
}
.go-checkout.highlight::before {
    content: "";
    width: 100%;
    height: 100%;
    background: #00000087;
    left: 0;
    top: 0;
    position: fixed;
    z-index: -2;
}
.go-checkout.highlight::after {
    content: "";
    width: 100%;
    height: 100%;
    background: #fff;
    left: 0;
    top: 0;
    position: absolute;
    z-index: -1;
}
/* .onboard-step.step-3 {
    top: -171px;
    max-width: 500px;
    right: 73px;
    box-shadow: 0px 0px 5px 0px #3333331c;
    width: calc(100% + 400px);
}
.onboard-step.step-3::before {
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
    left: 99%;
    border-top:1px solid black;
    border-right:1px solid black;
    border-radius: 5px;
    bottom: -5px;
    box-shadow: 8px 7px 8px 0px #33333314;
} */

.onboard-step.step-3 {
    right: 50%;
    max-width: 300px;
    top: unset;
    position: fixed;
    transform: translate(50%, -50%);
    bottom: 65px;
    width: 280px;
    background-color: #fff;
    /* backdrop-filter: blur(4px); */
}

@media only screen and (min-width: 768px) {
    .onboard-step.step-3 {
        background-color: #ffffff;
        
    }
    /* .onboard-step.step-3::before {
        display: none!important;
    } */
}

.btn_arrow_check {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.onboard-step.step-3::before {
    bottom: unset;
    left: 50%;
    top: calc(100% + -4px);
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    border-top: 0;
    border-radius: 0 0 5px 0;
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
    box-shadow: 8px 7px 8px 0px #33333314;
}

/*==== checkout page classes ====*/
.checkout-left-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.chekcout-filters ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
}
.chekcout-filters ul li {
    list-style: none;
    margin-left: 15px;
}
.chekcout-filters ul li a {
    color: var(--color);
}
.chekcout-filters ul li a:hover, .chekcout-filters ul li a.active{
    color: var(--darkblue);

}
.checkout-table thead::before {
    border: 1px solid #3333;
    border-radius: 5px 5px 0 0;
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
}
.checkout-table thead {
    position: relative;
}
.checkout-table thead tr th {
    padding: 15px 25px;
    font-size: 14px;
    text-transform: uppercase;
    color: var(--color);
    font-weight: 500;
}
.checkout-table thead tr th .btn {
    margin-left: 7px;
    color: var(--color);
}
.checkout-table thead tr th .btn:hover{
    color: #333;
}
.checkout-table tbody tr td {
    padding: 15px 25px;
    vertical-align: middle;
    font-size: 14px;
    color: var(--color);
}
.gift-logo {
    width: 50px;
    height: 44px;
    border: 2px solid #D7DFE9;
    border-radius: 4px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 50px;
}
.gift-logo img {
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
}
.checkout-table tbody tr td .btn {
    color: var(--color);
}
.checkout-table tbody tr td .btn:hover {
    color: #333;
}
.checkout-left-header h3 {
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: var(--darkblue);
}
.return-btn {
    color: var(--color);
    font-weight: 400;
    text-transform: uppercase;
    font-size: 13px;
}
.return-btn:hover{
    color: var(--darkblue);
}
.progress-labels {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}
.pblock-icon {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    margin-right: 7px;
}
.pblock-label {
    display: flex;
    align-items: center;
    margin-right: 15px;
}
.checkout-rightp {
    min-height: 100vh;
}
.text-orange{
    color: var(--orange);
}
.redeem-alert {
    background: #FFF3F5;
    border: 1px solid #FF0B37;
    border-radius: 5px;
    display: flex;
}
.ralert-con {
    color: #FF0B37;
    font-size: 24px;
}
.ralert-content {
    margin: 0 15px;
    color: #FF0B37;
}
.ralert-content h6 {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 7px;
}
.ralert-content p {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
}
.ralert-btn {
    border: 1px solid #FF0B37;
    border-radius: 999px;
    color: #FF0B37;
    padding: 3px 16px;
    font-size: 15px;
    font-weight: 500;
    transition: all ease 0.3s;
}
.ralert-btn:hover{
    background: #FF0B37;
    color: #fff;
    transition: all ease 0.3s;
}
.checkout-right-bottom h5 {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
}
.checkout-table thead tr th .btn.active i {
    transform: rotateX(180deg);
    transition: all ease 0.3s;
}
.checkout-table thead tr th .btn i {
    transform: rotateX(0deg);
    transition: all ease 0.3s;
}

/*==== All Brands classes ====*/

.allbrands-head {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: var(--darkblue);
    text-align: center;
}

.progress-left.prg_middle span {
    top: 12px;
}

/*==== payout confirmation classes ====*/

.confetti {
    position: absolute;
    padding: 2.2em 1.8em;
    width: 100%;
    overflow: hidden;
    min-height: 100vh;
    z-index: -1;
}

.confetti-piece {
  position: absolute;
  width: 8px;
  height: 16px;
  background: #ffd300;
  top: 0;
  opacity: 0;
}
.confetti-piece:nth-child(1) {
  left: 7%;
  transform: rotate(-74deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 107ms;
  animation-duration: 1188ms;
}
.confetti-piece:nth-child(2) {
  left: 14%;
  transform: rotate(-71deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 334ms;
  animation-duration: 886ms;
}
.confetti-piece:nth-child(3) {
  left: 21%;
  transform: rotate(24deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 42ms;
  animation-duration: 814ms;
}
.confetti-piece:nth-child(4) {
  left: 28%;
  transform: rotate(-42deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 124ms;
  animation-duration: 710ms;
}
.confetti-piece:nth-child(5) {
  left: 35%;
  transform: rotate(24deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 39ms;
  animation-duration: 985ms;
}
.confetti-piece:nth-child(6) {
  left: 42%;
  transform: rotate(3deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 113ms;
  animation-duration: 727ms;
}
.confetti-piece:nth-child(7) {
  left: 49%;
  transform: rotate(31deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 196ms;
  animation-duration: 895ms;
}
.confetti-piece:nth-child(8) {
  left: 56%;
  transform: rotate(-20deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 44ms;
  animation-duration: 844ms;
}
.confetti-piece:nth-child(9) {
  left: 63%;
  transform: rotate(2deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 129ms;
  animation-duration: 707ms;
}
.confetti-piece:nth-child(10) {
  left: 70%;
  transform: rotate(35deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 39ms;
  animation-duration: 813ms;
}
.confetti-piece:nth-child(11) {
  left: 77%;
  transform: rotate(-63deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 447ms;
  animation-duration: 791ms;
}
.confetti-piece:nth-child(12) {
  left: 84%;
  transform: rotate(13deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 479ms;
  animation-duration: 888ms;
}
.confetti-piece:nth-child(13) {
  left: 91%;
  transform: rotate(-38deg);
  animation: makeItRain 1000ms infinite ease-out;
  animation-delay: 226ms;
  animation-duration: 1042ms;
}
.confetti-piece:nth-child(odd) {
  background: #17d3ff;
}
.confetti-piece:nth-child(even) {
  z-index: 1;
}
.confetti-piece:nth-child(4n) {
  width: 5px;
  height: 12px;
  animation-duration: 2000ms;
}
.confetti-piece:nth-child(3n) {
  width: 3px;
  height: 10px;
  animation-duration: 2500ms;
  animation-delay: 1000ms;
}
.confetti-piece:nth-child(4n-7) {
  background: #ff4e91;
}

@keyframes makeItRain {
  from {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
  to {
    transform: translateY(200px);
  }
}

.pconfirmation-area {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: max(700px, 90vh);
    text-align: center;
}
.cngt-title {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: var(--darkblue);
}
.cngta-block h2 {
    font-weight: 700;
    font-size: 80px;
    line-height: 88px;
}
.text-blue{
    color: var(--darkblue);
}
.cngta-block p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--darkblue);
}
.recvupdate {
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: var(--darkblue);
}
.cngt-btns .btn {
    max-width: 356px;
}
.cngt-btns .btn {
    max-width: 356px;
    display: block;
    margin: 40px auto;
}
.cngt-btns .btn {
    max-width: 356px;
    display: block;
    margin: 30px auto;
    border-radius: 999px;
    font-size: 14px;
}
.otherp-btn {
    padding: 8px 16px;
    color: var(--darkblue);
}
.cngt-vs h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: var(--darkblue);
}

.go-checkout.empty {
    bottom: calc(0% - 60px);
}

.paginationsearch:focus{

    outline: none;
    border: 2px solid #ccc;
    border-radius: 4px;

}

/* .business-dash{
    text-align: center;
    margin: 2px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    padding-top: 5px;
    padding-bottom: 5px;
} */
.cart-count {
    position: absolute;
    top: -12px;
    right: -2px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: var(--newMainBlue);
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
  }

  .nav-cart{
    position: relative;
    cursor: pointer;
  }
  .welcome-img-business{
    overflow: hidden;
    min-height: 309px;
    position: relative;
    z-index: 0;
  }
  .welcome-img-business > img {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: auto;
    /* object-fit: cover; */

  }
  .coinImg{
    width: 110px;
    height: 90px;
    margin: auto;
  }
  .customerDot{
   min-height: 20px;
    min-width: 20px;
    margin-right: 6px;
    border-radius: 50%;
    background: #2665F2;
  }
  .customerDotactive{
    min-height: 20px;
    min-width: 20px;
    margin-right: 6px;
    border-radius: 50%;
    background: #65B5FF;
  }

  .bigCirclePie{
    margin-top: 15px;
    align-items: center;
    display: flex;
    max-width: 170px;
     height: 170px;
     border-radius: 50%;
     border: 10px solid #FF7020;
  }
  .smallCirclePie{
    width: 60%;
    height: 60%;
    border-radius: 50%;
    background-color: #65B5FF;
    text-align: center;
    margin: auto;
    position: absolute;
    top: 50%;
    right: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%);
  }
 




  .progress_body {
    width: 100%;
    height: 10px;
    border-radius: 28px;
    background-color: #747373;
}

.progres {
    cursor: pointer;
    border: none;
    height: 10px;
    background-color: #ff5300;
    position: relative;
}

.progres:nth-child(1){
    border-radius: 28px 0px 0px 28px;
}

.progres:nth-child(1)>span {
    display: none;
}

.progres:nth-child(1):hover>span {
    display: block;
}

.progres:nth-child(1)>span,
.progres:nth-child(1):hover>span {
    position: absolute;
    left: 50%;
    top: -187%;
    background-color: #ff5300;
    transform: translate(-50%, -50%);
    padding: 5px;
    color: #fff;
    font-size: 10px;
    z-index: 2;
}


.progres:nth-child(1)>span+span {
    display: none;
}

.progres:nth-child(1):hover>span+span {
    display: block;
}

.progres:nth-child(1)>span+span,
.progres:nth-child(1):hover>span+span {
    z-index: 1;
    content: '';
    position: absolute;
    width: 0px;
    height: 0px;
    bottom: 50%;
    transform: rotate(45deg) translate(-17%, 66%);
    left: 50%;
    background-color: #ff5300;
}







.progres:nth-child(2)>span {
    display: none;
}

.progres:nth-child(2):hover>span {
    display: block;
}

.progres:nth-child(2)>span,
.progres:nth-child(2):hover>span {
    position: absolute;
    left: 49%;
    bottom: -30px;
    background: green;
    transform: translate(-50%, 0px);
    padding: 5px;
    font-size: 10px;
    color: #fff;
    z-index: 2;
}


.progres:nth-child(2)>span+span {
    display: none;
}

.progres:nth-child(2):hover>span+span {
    display: block;
}

.progres:nth-child(2)>span+span,
.progres:nth-child(2):hover>span+span {
    z-index: 1;
    content: '';
    position: absolute;
    width: 0px;
    height: 0px;
    bottom: -12px;
    transform: rotate(45deg) translate(-17%, 7px);
    left: 50%;
    background-color: green;

}





.progres:nth-child(3)>span {
    display: none;
}

.progres:nth-child(3):hover>span {
    display: block;
}

.progres:nth-child(3)>span,
.progres:nth-child(3):hover>span {
    position: absolute;
    left: 50%;
    top: -187%;
    background-color: rgb(128, 98, 0);
    transform: translate(-50%, -50%);
    padding: 5px;
    color: #fff;
    font-size: 10px;
    z-index: 2;
}


.progres:nth-child(3)>span+span {
    display: none;
}

.progres:nth-child(3):hover>span+span {
    display: block;
}

.progres:nth-child(3)>span+span,
.progres:nth-child(3):hover>span+span {
    z-index: 1;
    content: '';
    position: absolute;
    width: 0px;
    height: 0px;
    bottom: 50%;
    transform: rotate(45deg) translate(-17%, 66%);
    left: 50%;
    background-color: rgb(128, 98, 0);
}







.progres:nth-child(4)>span {
    display: none;
}

.progres:nth-child(4):hover>span {
    display: block;
}

.progres:nth-child(4)>span,
.progres:nth-child(4):hover>span {
    position: absolute;
    left: 49%;
    bottom: -30px;
    background: rgb(0, 87, 128);
    transform: translate(-50%, 0px);
    padding: 5px;
    font-size: 10px;
    color: #fff;
    z-index: 2;
}


.progres:nth-child(4)>span+span {
    display: none;
}

.progres:nth-child(4):hover>span+span {
    display: block;
}

.progres:nth-child(4)>span+span,
.progres:nth-child(4):hover>span+span {
    z-index: 1;
    content: '';
    position: absolute;
    width: 0px;
    height: 0px;
    bottom: -12px;
    transform: rotate(45deg) translate(-17%, 7px);
    left: 50%;
    background-color: rgb(0, 87, 128);

}

.fixed_style{
    width: 100%;
}
.progress_body {
    display: flex;
}

.task-progress {
    margin: 35px 0px ;
    display: flex;
    align-items: center;
}
.proItem .col-lg-3.col-md-6 {
    width: 100%!important;
    height: 10% !important
}

/* @media screen and (min-width:690px) and (max-width:992px){
    .proItem .col-lg-3.col-md-6 {
       width: 75% !important;
    }

} */
/* @media screen and (min-width:1640px) {
    .proItem .col-lg-3.col-md-6 {
        width: 76%!important;
        height: 10% !important
    }
} */
.toggle_button{
    position: absolute;
    bottom:-16px;
   }
   .show_box{
    transition: 0.5s;
    margin-top: -140px !important;
   }
   .hide_box{
    margin-top: 0px !important;
    transition: 0.5s;
   }

   @media screen and (min-width:425.98px) and (max-width:576px){
    .show_box{
        margin-top: -160px !important;
    }
   }
   @media screen and (max-width:425px) {
    .show_box{
        margin-top: -205px !important;
    }
   }
   @media screen and (max-width:324px){
    .show_box{
        margin-top: -252px !important;
    }
   }
@media screen and (max-width:425px){
    
   .go-category{
    bottom: calc(0% - 85px);
    transition: all ease 0.5s;
   }
   .go-category.active{
    bottom: 0;
    transition: all ease 0.5s;
   }
   .go-category.notable{
    bottom: 0;
   }
   .go-category.highlight::before{
    content: "";
    width: 100%;
    height: 100%;
    background: #00000087;
    left: 0;
    top: 0;
    position: fixed;
    z-index: -2;
   }
   .go-category.highlight::after{
    content: "";
    width: 100%;
    height: 100%;
    background: #fff;
    left: 0;
    top: 0;
    position: absolute;
    z-index: -1;
   }
   .go-category.empty{
    bottom: calc(0% - 60px);
   }
   .mobile_category{
    margin: 0px 0px !important;
   }

}
@media screen and (min-width:992px) and (max-width:2600px){
    .go-category{
     margin-bottom: -14px !important;
    }
}
@media screen  and (min-width:992px) and (max-width:1199.98px) {
    .listing-input-btn {
        padding: 3px;
        width: 26px;
        height: 25px;
    }
    .listing-input-btn svg {
        height: 11px !important;
        width: 11px !important;
        transform: scale(1) !important;
    }

    .inputwithunit .form-control{
        line-height: 20px;
    }
    .listing-bottom-right{
        margin-left: 0px;
    }
    .listing-bottom-right h6 {
        font-size: 15px !important;
    }
    .dropdown_listing{
        font-size: 16px !important;
        line-height: 22px !important;
    }
    .listing-name {
     min-height: 48px;
    }
    .responsive_text{
        font-size: 12px;
        margin-top: 0px;
    }
    .listing-block{
        height: 98% !important;
    }
    
    .view-listing-btn{
        line-height: 7px;
        margin-top: -20px;
    }
}
@media screen  and (min-width:1200px){
    .left_bottom_div{
        margin-left: 0px;
    }
}
@media screen and (max-width:576px){
    /* .dropdown_listing{
        max-width: 47% !important;
        
    } */
    
}

@media screen  and (max-width:576px){
    .first_div{
        margin: 0px auto !important;
    }
    .second_div{
        margin: 0px auto !important;
    }
   
}

listing_logo_img {
    width: 100%;
    max-width: 200px !important;
    height: 34px;
    border-radius: 2px;
}
.listing-logo {
    width: 66px;
    height: 56px;
}

.first_div{
    width: 150px;
    /* margin: 0px auto !important; */
}
.second_div{
    width: 150px;
    margin-top: 7px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.second_div a.add_button_New {
    width: 75px;
    margin: 0  !important;
}

.proItem .main_div.active{
display: flex;
flex-direction: column;
justify-content: end;
align-items: center;
margin-right: 0px !important;
/* margin-top: 22px; */
}
@media screen and (max-width:425px){
    .proItem .main_div.active{
        margin-left: 0px !important;
    }
}
.main_div.active{
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    }

/* @media screen  and (max-width:576px){
    
    .button_dropdown{
        margin-left: 8px !important;
    }
} */
/* @media screen and (min-width:768px) and (max-width:1199.98px){
    .button_dropdown{
        margin-left: 28px !important;
    }
} */
/* @media screen and (min-width:1200px) and (max-width:1399.99px){
  .button_dropdown{
    margin-left: 17px !important;
}
  } */

@media screen and (min-width:992px) and (max-width:1199.99px){
    .second_div a.add_button_New{
        width: 75px;
        margin-left: -13px !important;
    }
}
/* @media screen and (max-width:1400px){
    .add_button_New{
        margin-left: 3px;
    }
} */
/* .swiper.swiper-initialized{
margin: 20px !important;
} */


.listing-bottom-right-giftcards span {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--blue);
}
.listing-bottom-right-giftcards h6 {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    align-items: center;
    color: var(--blue);
}
.listing-bottom-right-giftcards h6 span{
    font-size: 24px!important;
    line-height: 32px;
}
.listing-bottom-right-giftcards {
    text-align: center;
}
.listing-bottom-right-giftcards h6 {
    margin: 5px auto;
    width: -moz-fit-content;
    width: fit-content;
}


.Toastify__toast-body{
 font-family: var(--font-family) ;
}



/* PDF SCROLL */
/* .customer-modal{
    width: 100%;
     height: 350px;
     overflow-y:'auto';
} */

.custom-modal {
    max-width: 350px; 
    margin: 0 auto; 
  }

.position_relative{
    overflow-y: auto;
    overflow: hiden;
/* max-width: 350px; */
height: 400px;
}
  .pdf-viewer-container {
    width: 100%;
    /* height: 800px; */
    zoom: 100%;
  }
  
  @media screen and (max-width: 600px) {
    .pdf-viewer-container {
      width: 100%;
      /* height: 400px; */ 
      zoom: 100%;
    }
    .custom-modal {
        max-width: 400px; 
        margin: 0 auto; 
      }
      .position_relative{
        /* overflow-y: auto; */
        /* overflow: hiden; */
    /* max-width: 400px; */
    /* max-height: 349px; */
    }
  }

  @media screen and (min-width:1550px) and (max-width:2000px) {
    .pdf-viewer-container {
        width: 100%;
        height: 400px;
        zoom: 100%;
      }
      .custom-modal {
          max-width: 500px !important; 
          max-height: 700px !important;
          margin: 0 auto; 
        }
        .position_relative{
          overflow-y: auto;
          overflow: hiden;
      /* max-width: 480px; */
      max-height: 450px;
      }
  }
  
  @media screen and (min-width: 601px) and (max-width: 1200px) {
    .pdf-viewer-container {
      width: 100%;
      /* height: 350px; */
      zoom: 100%; 
    }
    .custom-modal {
        max-width: 350px; 
        margin: 0 auto; 
      }
  }
  
  @media screen and (min-width: 993px) and (max-width: 1200px) {
    .pdf-viewer-container {
      width: 100%;
      /* height: 350px;  */
      zoom: 100%;
    }
    .custom-modal {
        max-width: 350px; 
        margin: 0 auto; 
      }
    
  }

  @media screen and (min-width: 1201px) {
    .pdf-viewer-container {
      width: 100%;
      /* height: 350px; */
      zoom: 100%;
    }
    .custom-modal {
        max-width: 350px; 
        margin: 0 auto; 
      }
  }
  


/* 
  .scroll-modal::-webkit-scrollbar {
    width: 5px;
    height: 4px;
  }
  .scroll-modal::-webkit-scrollbar-thumb {
    background-color: red;
    border-radius: 6px;
  }
  .scroll-modal::-webkit-scrollbar-track {
    background-color: transparent;
  } */




.product_select_box{
    font-weight: bolder;
    color: #000;
    background-color: #fff;
}
  .product_select_box ul {
    position: absolute;
    top: 31px;
    left: -11px;
    width: 100%;
    min-width: 81px;
    padding: 2px;
    background-color: #fff !important;
    border: 1px solid gray;
    border-radius: 5px;
    font-weight: bolder;
    color: #000;
    z-index: 1;
}
.card_image_style{
    height: 160px;
    object-fit: cover;
}
.fixed-custom-footer-customer {
    /* position: fixed; */
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #ffffff;
}


@media screen and (max-width: 15000px) and (min-width: 1200px) {
    /* .customSearchMarginFooter{
    margin-top: 618px;
    }
    .customCategoryMarginFooter{
        margin-top: 300px;
    } */
}

@media screen and (max-width: 1200px) and (min-width: 400px) {
    .responsivePartner{
        white-space: nowrap;
    }
}

.customGap{
    gap: 20px
}
@media screen and (max-width: 390px) {
    .customGap{
        gap: 12px
    }
}
.listBox {
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  /* scrollbar-width: thin; */
  /* scrollbar-color: grey #eeeeee; */
}

.listBox::-webkit-scrollbar {
  width: 5px;
}

.listBox::-webkit-scrollbar-track {
  background: #eeeeee;
}

.listBox::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 5px;
}
.listBox::-webkit-scrollbar-button {
  display: none;
}
.onBoardPromoMarginTop{
    margin-top: 200px;
}
html, body {
    width: 100%;
    overflow-x: clip;
}
@media screen and (max-width: 992px) {
    .onBoardPromoMarginTop{
        margin-top: 350px;
    }
}
@media screen and (max-width: 768px) {
    .onBoardPromoMarginTop{
        margin-top: 370px;
    }
}

.checkout_offcanvas_content_onboard{
   bottom: 0px !important;
   /* top: auto !important; */
   max-width: 400px ;
   margin-top: 128px;
   /* height: 86.60% !important; */
   border: grey !important;
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
   position: invert-layer !important;
   
 }
 .checkout_offcanvas_onboard {
    bottom:0!important;
    top:unset!important;
  }
  .offcanvas_body_onboard_height{
      height: 65%;
  }
  .offcanvas_footer_onboard_height{
      height: 35%;
  }
 @media screen and  (min-width: 1200px){
    .zoomScreenOnBoard{
      zoom: 0.8;
    }
    .checkout_offcanvas_content_onboard{
        max-width: 350px;
        margin-top: 102px;
    }
    .offcanvas_body_onboard_height{
        height: 49% !important;
    }
    .offcanvas_footer_onboard_height{
        height: 51% !important;
    }
    .checkout_offcanvas_onboard {
        height: calc(-132px + 100vh + 5.35%)!important;
    }
}
 @media screen and  (min-width: 1540px){
    .zoomScreenOnBoard{
      zoom: 100%;
    }
    .offcanvas_body_onboard_height{
        height: 65% !important;
    }
    .offcanvas_footer_onboard_height{
        height: 35% !important;
    }
    .checkout_offcanvas_onboard {
        height: calc(-180px + 100vh + 5.35%)!important;
    }
    .checkout_offcanvas_content_onboard{
        max-width: 400px;
        margin-top: 129px;
    }
    
}

.custom_discount {
    right: 0px;
    top: 0px;
    color: white;
    cursor: pointer;
    min-width: auto;
    background-color: #68B942;
    font-weight: bold;
    border-bottom-left-radius: 15px;
    border-top-right-radius: 1px;
    z-index: 1;
  }
  .custom_discount:hover {
    box-shadow: 0 1px 5px rgb(0, 0, 0);
    font-weight: bold;
}
.custom_discount_promoBrand {
    right: 0px;
    top: 0px;
    color: white;
    cursor: pointer;
    width: auto;
    background-color: #68B942;
    font-weight: bold;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 15px;
  }
  .custom_discount_checkout {
    right: -39px;
    top: -17px;
    color: white;
    cursor: pointer;
    min-width: 60px;
    background-color: #68B942;
    font-weight: bold;
    font-size: 10px;
}
  .responsive_card_footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
  }
  @media screen and (max-width: 550px){
    .responsive_card_footer{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        /* margin: 0px 16px; */
    }
    .card-footer{
        padding: 5px 0px 10px 0px;
        
    }
    .inputwithunit .responsive_inputwithunit {
        width: 80px;
        
    }
    .inputwithunit .responsive_select_width  {
        width: 134px;
    }
    .responsive_card_footer div:nth-child(2){
       max-width: 100% !important;
    }
    /* .inputwithunit .responsive_dollar{
        left: 40px 
    } */
    .responsive_button_style{
        font-size: 16px;
        font-weight: bold;
        padding: 55px;
    }
   
}

  .responsive_text_new_bonus{
    color: rgb(245, 196, 0);
    font-size: 12px ;
}
  @media screen and (max-width: 550px){
    .responsive_button_style{
        font-size: 16px;
        font-weight: bold;
        padding: 55px;
    }
    .responsive_text_new{
        font-size: 15px;    
    }
    .responsive_text_new_bonus{
        font-size: 14px ;
        padding-left: 4px ;    
    }
  }

  @media screen and (max-width: 475px){
    .inputwithunit .responsive_inputwithunit {
        width: 90px;
        
    }
    .inputwithunit .responsive_select_width  {
        width: 134px;
    }
  }
  @media screen and (max-width: 490px){
  }

  .card_container_transaction {
    max-width: 380px;
    margin: 30px auto;
    padding: 20px;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);
}
  .card_container_transaction_list {
    max-width: 380px;
    margin: 40px auto;
    padding: 20px;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);
}
.card_container_transaction .header, .card-container .content {
    margin-bottom: 1rem;
}
.custom_status_tag{
    top: -26px;
    right: 0px;
    color: #fff;
    border-radius: 20px;
    display: flex;
    width: auto;
    padding: 7px 10px;
    justify-content: center;
    align-items: center;
}

.product-listing.centar_product_listing {
    min-height: 85vh;
}

@media screen and (max-width: 768px) {
    .responsive_button_minus{
        font-size: 24px !important;
    }
}

.table_scroll_container{
    max-height: 353px;
    overflow-y: auto;
    position: relative;
}
.table_scroll_container {
    thead {
      position: sticky;
      top: 0;
      z-index: 1;
    }
  
    &::-webkit-scrollbar {
      border-radius: 10px;
      width: 5px;
      height: 6px;
    }
  
    &::-webkit-scrollbar-track {
      background: #eeeeee;
      border-radius: 10px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: #818181;
      border-radius: 10px;
    }
  }
  .infoCircle:hover {
      font-size: 22px;
      box-shadow: 1px 1px 5px rgba(17, 17, 17, 0.5);
      border-radius: 50%;
  }
  .btn-add:hover {
      box-shadow: 1px 1px 5px  var(--newOrangeHover) !important;
      font-weight: 700;
      filter: contrast(100%);
  }
  .hover_checkout_bar:hover {
      box-shadow: 1px 1px 8px  var(--newOrangeHover) !important;
      transition: box-shadow 0.3s ease;
      font-weight: 700;
  }

  .termsuse_hover:hover {
      text-shadow: 2px 2px 4px #0d6dfd77;
  }

  .trash-icon:hover {
    color: #000000 !important;
    transform: scale(1.2);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  .cart_hover:hover{
    /* color: #000000 !important; */
    transform: scale(1.05);
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
  }
  .button_hover:hover{
    box-shadow: 1px 1px 8px rgba(17, 17, 17, 0.5) !important;
    transition: box-shadow 0.3s ease;
    font-weight: 700;
    transform: scale(1.01);
  }
  .img_hover:hover{
    transition: box-shadow 0.3s ease;
    transform: scale(1.01);
  }
  .gift_image_container {
    overflow: hidden;
    cursor: pointer;
    border-top-left-radius: 8px;
  }
  
  .gift_image_hover {
    transition: transform 0.3s ease;
  }
  
  .gift_image_hover:hover {
    transform: scale(1.05);
  }
  .newCustomButton {
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

  .newCustomButton:hover {
    background-color: var(--newOrangeHover) !important ;
    border-color: var(--newOrangeHover) !important ;
}
  .newCustomSearch {
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

  .newCustomSearch:hover {
    background-color: var(--newMainBlueHover) !important ;
    border-color: var(--newMainBlueHover) !important ;
}

  .newModalHeaderColor{
    background-color: var(--newMainBlue) !important;
    color: #fff !important;
  }
  .newModalHeaderColor .btn-close {
    filter: invert(1);
    opacity: 1;
  }`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AACA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,yEAAyE;AAC3E;AACA,sBAAsB;AACtB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;IACI,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA,UAAU;EACV;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;;AAGF;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;AACA;GACG,6BAA6B;AAChC;AACA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;IACI,6BAA6B;EAC/B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;IACI;EACF,iBAAiB;;IAEf;AACJ;AACA;;;GAGG;AACH;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA,mCAAmC;;AAEnC;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;AAC1B;AACA,qBAAqB,yBAAyB,EAAE;KAC3C,EAAE,yBAAyB,EAAE;AAClC;IACI,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,sBAAsB;AAC1B;AACA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;;AAE9B;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA,+BAA+B;;AAE/B;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,iCAAiC;IACjC,WAAW;AACf;;AAEA;;GAEG;AACH;IACI,yBAAyB;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,wDAAwD;IACxD,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;AACA;;;GAGG;AACH;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;;;GAGG;;AAEH;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,gCAAgC;IAChC,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,OAAO;AACX;AACA;IACI,QAAQ;AACZ;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yCAAyC;IACzC,SAAS;AACb;;AAEA,sCAAsC;;AAEtC;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;AACA;;GAEG;AACH;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,QAAQ;AACZ;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,QAAQ;IACR,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,WAAW;IACX,uCAAuC;AAC3C;AACA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oDAAoD;IACpD,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;GACf,WAAW;IACV,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,iBAAiB;;AAErB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS,EAAE,0CAA0C;IACrD,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU,EAAE,oCAAoC;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,8BAA8B;AAClC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,8BAA8B;AAClC;;;AAGA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;;AAE3B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,yBAAyB;AAC7B;AACA;IACI,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;;AAGA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;AACA,UAAU;AACV,gBAAgB;AAChB,aAAa;;AAEb;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,qBAAqB;AACzB;AACA;;GAEG;AACH;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,OAAO;IACP,MAAM;IACN,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,yCAAyC;IACzC,SAAS;IACT,kBAAkB;AACtB;AACA;;;;;;;GAOG;AACH;IACI,QAAQ;IACR,YAAY;IACZ,wBAAwB;IACxB,qCAAqC;IACrC,2BAA2B;AAC/B;AACA;;;;;;;;;;;GAWG;AACH;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,uBAAuB;IACvB,kBAAkB;IAClB,qCAAqC;IACrC,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,OAAO;IACP,MAAM;IACN,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,kBAAkB;IAClB,WAAW;AACf;AACA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;IACI,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI;QACI,yBAAyB;;IAE7B;IACA;;OAEG;AACP;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;;AAE1B;AACA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA,wCAAwC;;AAExC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,MAAM;EACN,UAAU;AACZ;AACA;EACE,QAAQ;EACR,yBAAyB;EAEjB,8CAA8C;EAE9C,sBAAsB;EAEtB,0BAA0B;AACpC;AACA;EACE,SAAS;EACT,yBAAyB;EAEjB,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,wBAAwB;EAEhB,8CAA8C;EAE9C,qBAAqB;EAErB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,yBAAyB;EAEjB,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,wBAAwB;EAEhB,8CAA8C;EAE9C,qBAAqB;EAErB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,uBAAuB;EAEf,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,wBAAwB;EAEhB,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,yBAAyB;EAEjB,8CAA8C;EAE9C,qBAAqB;EAErB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,uBAAuB;EAEf,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,wBAAwB;EAEhB,8CAA8C;EAE9C,qBAAqB;EAErB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,yBAAyB;EAEjB,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,wBAAwB;EAEhB,8CAA8C;EAE9C,sBAAsB;EAEtB,yBAAyB;AACnC;AACA;EACE,SAAS;EACT,yBAAyB;EAEjB,8CAA8C;EAE9C,sBAAsB;EAEtB,0BAA0B;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;EAEJ,0BAA0B;AACpC;AACA;EACE,UAAU;EACV,YAAY;EAEJ,0BAA0B;EAE1B,uBAAuB;AACjC;AACA;EACE,mBAAmB;AACrB;;AAcA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;;AAEtB;;AAEA;;;;;;GAMG;AACH;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,uBAAuB;;EAEzB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;EACd;EACA;GACC,gBAAgB;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;KACf,aAAa;KACb,kBAAkB;KAClB,0BAA0B;EAC7B;EACA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;EACjC;;;;;;EAMA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,6CAA6C;IAC7C,SAAS;IACT,yBAAyB;AAC7B;;;;;;;;AAQA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;AACd;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,6CAA6C;IAC7C,SAAS;IACT,uBAAuB;;AAE3B;;;;;;AAMA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iCAAiC;IACjC,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,6CAA6C;IAC7C,SAAS;IACT,iCAAiC;AACrC;;;;;;;;AAQA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;AACd;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,6CAA6C;IAC7C,SAAS;IACT,iCAAiC;;AAErC;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;;;;GAKG;AACH;;;;;GAKG;AACH;IACI,kBAAkB;IAClB,YAAY;GACb;GACA;IACC,gBAAgB;IAChB,6BAA6B;GAC9B;GACA;IACC,0BAA0B;IAC1B,gBAAgB;GACjB;;GAEA;IACC;QACI,6BAA6B;IACjC;GACD;GACA;IACC;QACI,6BAA6B;IACjC;GACD;GACA;IACC;QACI,6BAA6B;IACjC;GACD;AACH;;GAEG;IACC,uBAAuB;IACvB,yBAAyB;GAC1B;GACA;IACC,SAAS;IACT,yBAAyB;GAC1B;GACA;IACC,SAAS;GACV;GACA;IACC,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,OAAO;IACP,MAAM;IACN,eAAe;IACf,WAAW;GACZ;GACA;IACC,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,kBAAkB;IAClB,WAAW;GACZ;GACA;IACC,uBAAuB;GACxB;GACA;IACC,0BAA0B;GAC3B;;AAEH;AACA;IACI;KACC,+BAA+B;IAChC;AACJ;AACA;IACI;QACI,YAAY;QACZ,WAAW;QACX,YAAY;IAChB;IACA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;KACC,gBAAgB;IACjB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;;;OAGG;;AAEP;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;;AAEJ;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,oBAAoB;AACpB,mBAAmB;AACnB,4BAA4B;AAC5B,sBAAsB;AACtB;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB;;AAEJ;;;;;GAKG;AACH;;;;GAIG;AACH;;;;KAIK;;AAEL;IACI;QACI,WAAW;QACX,6BAA6B;IACjC;AACJ;AACA;;;;GAIG;AACH;;GAEG;;;AAGH;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;AACtB;;;AAGA;CACC,gCAAgC;AACjC;;;;AAIA,eAAe;AACf;;;;GAIG;;AAEH;IACI,gBAAgB;IAChB,cAAc;EAChB;;AAEF;IACI,gBAAgB;IAChB,eAAe;AACnB,sBAAsB;AACtB,aAAa;AACb;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE;MACE,WAAW;MACX,mBAAmB;MACnB,UAAU;IACZ;IACA;QACI,gBAAgB;QAChB,cAAc;MAChB;MACA;QACE,sBAAsB;QACtB,qBAAqB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB;EACF;;EAEA;IACE;QACI,WAAW;QACX,aAAa;QACb,UAAU;MACZ;MACA;UACI,2BAA2B;UAC3B,4BAA4B;UAC5B,cAAc;QAChB;QACA;UACE,gBAAgB;UAChB,eAAe;MACnB,sBAAsB;MACtB,iBAAiB;MACjB;EACJ;;EAEA;IACE;MACE,WAAW;MACX,mBAAmB;MACnB,UAAU;IACZ;IACA;QACI,gBAAgB;QAChB,cAAc;MAChB;EACJ;;EAEA;IACE;MACE,WAAW;MACX,oBAAoB;MACpB,UAAU;IACZ;IACA;QACI,gBAAgB;QAChB,cAAc;MAChB;;EAEJ;;EAEA;IACE;MACE,WAAW;MACX,mBAAmB;MACnB,UAAU;IACZ;IACA;QACI,gBAAgB;QAChB,cAAc;MAChB;EACJ;;;;AAIF;;;;;;;;;;;KAWK;;;;;AAKL;IACI,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,yBAAyB;AAC7B;;;AAGA;IACI;;;;;OAKG;AACP;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;GACG,sBAAsB;GACtB,0BAA0B;GAC1B,iBAAiB;GACjB,iBAAiB;GACjB,+BAA+B;GAC/B,uBAAuB;GACvB,mDAAmD;GACnD,iCAAiC;;CAEnC;CACA;IACG,kBAAkB;IAClB,mBAAmB;EACrB;EACA;MACI,WAAW;EACf;EACA;MACI,WAAW;EACf;CACD;IACG;MACE,SAAS;IACX;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,8CAA8C;IAClD;AACJ;CACC;IACG;MACE,UAAU;IACZ;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,8CAA8C;IAClD;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;AAEJ;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,+BAA+B;IAC/B,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,6BAA6B;IAC7B,+BAA+B;EACjC;EACA;IACE,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;EACE;QACM,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;EACzB;EACA;IACE;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;QACtB,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,yBAAyB;;IAE7B;IACA;QACI,WAAW;;IAEf;IACA;QACI,YAAY;IAChB;IACA;OACG,0BAA0B;IAC7B;IACA;;OAEG;IACH;QACI,eAAe;QACf,iBAAiB;QACjB,aAAa;IACjB;;AAEJ;;EAEE;IACE,uBAAuB;IACvB,gBAAgB;AACpB;EACE;IACE;QACI,eAAe;QACf,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;EACF;;EAEA;IACE;QACI,WAAW;;IAEf;IACA;QACI,YAAY;IAChB;EACF;EACA;EACA;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI;MACE,gBAAgB;MAChB,MAAM;MACN,UAAU;IACZ;;IAEA;MACE,mBAAmB;MACnB,UAAU;MACV,WAAW;IACb;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;IACrB;EACF;EACA;MACI,eAAe;MACf,6CAA6C;MAC7C,kBAAkB;EACtB;EACA;MACI,yDAAyD;MACzD,gBAAgB;MAChB,sBAAsB;EAC1B;EACA;MACI,yDAAyD;MACzD,gCAAgC;MAChC,gBAAgB;EACpB;;EAEA;MACI,kCAAkC;EACtC;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;EAC1C;EACA;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,8CAA8C;EAChD;EACA;IACE,wDAAwD;IACxD,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,8DAA8D;AAClE;;EAEE;IACE,mDAAmD;IACnD,+CAA+C;AACnD;EACE;IACE,8DAA8D;AAClE;;EAEE;IACE,qDAAqD;IACrD,iDAAiD;AACrD;;EAEE;IACE,+CAA+C;IAC/C,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Baloo+Thambi+2:wght@400;500;600;700;800&display=swap');\n:root{\n  --font-family: 'Baloo Thambi 2', cursive;\n  --border-radius:  .25rem;\n  --border: 1px solid #ccc;\n  --orange: #FE7021;\n  --yellow: #F5C400;\n  --blue: #4221E5;\n  --newOrange: #FFAD31;\n  --newMainBlue: #2665F2;\n  --newMainBlueHover: #1F53C9;\n  --newLightBlue: #E8EDFB;\n  --newOrangeHover: #E69528; \n  /* --headingblue: #171F46; */\n  --darkblue: #151935;\n  --color:  #7E858E;\n  --line-height: 1.35;\n  --box-shadow: 0 0 5px 0 #3333;\n  --gradientclr: linear-gradient(93.59deg, #FF7020 -0.51%, #F5C400 105.82%);\n}\n/*==== Basic Css ====*/\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n#root{\n    /* height: 100vh; */\n  }\n\n  body::-webkit-scrollbar {\n    width: 5px;\n    border-radius: 10px;\n  }\n  \n  /* Track */\n  body::-webkit-scrollbar-track {\n    background: #65B5FF;\n    border-radius: 10px;\n  }\n  \n  /* Handle */\n  body::-webkit-scrollbar-thumb {\n    background: #2665F2;\n    border-radius: 10px;\n  }\n  \n  /* Handle on hover */\n  body::-webkit-scrollbar-thumb:hover {\n    background: #2665F2;\n    border-radius: 10px;\n  } \n\n\na, a:hover{\n  text-decoration: none!important;\n}\n\nh1,h2,h3,h4,h5,h6{\n  margin: 0;\n}\np{\n  margin: 0;\n}\nol li, ul li{\n  margin: 0;\n  padding: 0;\n}\nbody {\n    font-family: var(--font-family);\n    line-height: var(--line-height);\n    color: var(--color);\n    font-weight: 400;\n    width: 100%;\n    overflow-x: clip;\n}\n\n/*==== custom utility classes ====*/\n.btn {\n    box-shadow: none !important;\n    font-family: var(--font-family) ;\n}\n.onboard-footer .btn-main {\n   background-color: var(--blue); \n}\n.btn-main{\n  /* background-color: var(--blue); */\n  border-color: var(--blue);\n  color: #FFF;\n  padding: 8px 16px;\n  border-radius: 999px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n.add_button_New{\n    background-color: var(--blue);\n  border-color: var(--blue);\n  color: #FFF;\n  padding: 0px 20px;\n  border-radius: 999px;\n  font-weight: 500;\n  font-family: var(--font-family) ;\n  /* margin-left: 19px; */\n  font-size: 11px;\n  line-height: 29px;\n  /* width: 88%; */\n}\n@media screen and (max-width: 1440px) and (min-width: 1024px) {\n    .add_button_New{\n  padding: 0px 16px;\n\n    }\n}\n/* .reposnsive_margin{\n    position: relative;\n  top: 11px;\n} */\n.btn-main:hover, .btn-main:focus, .btn-main:active{\n  background-color: var(--blue);\n  border-color: var(--blue);\n  color: #FFF;\n}\n.text-main{\n  color: var(--newMainBlue)!important;\n}\n.text-dark{\n  color: var(--darkblue);\n}\n.text-yellow{\n  color:rgb(245, 196, 0);\n}\n.editPimage img {\n    width: 200px;\n    height: 200px;\n    object-fit: fill;\n    border-radius: .5rem;\n    object-position: center;\n}\n.bg-main{\n  background-color: var(--blue);\n}\n.chekout-middle-table {\n    max-height: 100px;\n    overflow-y: auto;\n}\n\n.btn-sub{\n  background-color: var(--darkblue);\n  border-color: var(--darkblue);\n}\n.text-sub{\n  color: var(--darkblue);\n}\n.bg-sub{\n  background-color: var(--darkblue);\n}\n.box-shadow{\n  box-shadow: var(--box-shadow);\n}\n.border{\n  border: var(--border);\n}\n/*==== favorite brand classes ====*/\n\n.brand-block {\n    width: auto;\n    /* max-width: 112px; */\n    height: 150px;\n    /* background: #FFFFFF; */\n    /* border: 2px solid #D7DFE9; */\n    border-radius: 14px;\n    /* padding-bottom: 32px; */\n    position: relative;\n    display: block;\n    text-decoration: none;\n}\n.brand-image {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.brand-footer {\n    background: #F5C40080;\n    border-radius: 0px 0px 4px 4px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n    text-align: center;\n    color: #171F46;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n}\n.slider-area{\n  position: relative;\n  padding: 0px 80px;\n}\n\n.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after {\n    content: \"\\f054\";\n    font-family: 'Font Awesome 5 Pro';\n    color: var(--darkblue);\n}\n\n.swiper-button-prev::after, .swiper-rtl .swiper-button-next::after {\n    content: \"\\f053\";\n    font-family: 'Font Awesome 5 Pro';\n    color: var(--darkblue);\n}\n.brand-block:hover { border: 2px solid #FF7020; border-radius: 10px 10px 10px\n 10px; transition: all ease 0.5s; }\n.section-header {\n    font-weight: 700;\n    font-size: max(36px, 2vw);\n    line-height: 1.25;\n    color: var(--darkblue);\n}\n.section-headers {\n    font-weight: 600;\n    font-size: max(20px, 1.2vw);\n    line-height: 1;\n    color: var(--darkblue);\n}\n.view-all{\n  min-width: 170px;\n}\n\n/*==== help need classes ====*/\n\n.charities-block ul li {\n    list-style: none;\n    margin-right: 40px;\n}\n\n.charities-block ul li:last-child{\n  margin-right: 0px;\n}\n\n.charities-block ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    /* justify-content: space-between; */\n    margin-top: 20px;\n}\n\n/*==== Reedem all classes ====*/\n\n.bg-light {\n    background: #E8EDFB!important;\n}\n\n.product-block img:hover {\n    transform: scale(1.135);\n    transition: all ease 0.35s;\n}\n\n.product-block img {\n    transform: scale(1);\n    transition: all ease 0.35s;\n}\n.product-block {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    /* min-width: 200px; */\n}\n.product-block span {\n    display: flex;\n    margin-top: 25px;\n    justify-content: center;\n    padding: 5px 10px;\n    background: #fff;\n    border-radius: 999px;\n    width: 100%;\n    text-align: center;\n    color: #333;\n    font-weight: 600;\n    border: 1px solid #ccc;\n    transition: all ease 0.3s;\n}\n\n.product-block:hover span{\n    transition: all ease 0.3s;\n    background:rgb(61, 5, 182);\n    border: 1px solid var(--darkblue);\n    color: #fff;\n}\n\n/* .custom-gap {\n    padding: 0px 7%;\n} */\n.delight-header p {\n    font-size: max(18px, 1vw);\n}\n.delight-img img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  object-fit: cover;\n}\n.delight-img {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n}\n.delight-card {\n    background: #fff;\n    box-shadow: 0px 0px 5px 0px #3333;\n    margin: 25px 0;\n    filter: drop-shadow(0px 8px 40px rgba(23, 31, 70, 0.08));\n    border-radius: .5rem;\n    overflow: hidden;\n    display: block;\n    transition: all ease 0.25s;\n}\n/* .delight-card:hover{\n    transform: translateY(70px);\n    transition: all ease 0.25s;\n} */\n.delight-logos {\n    min-height: 109px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 25px;\n}\n.delight-logos p {\n    font-weight: 500;\n    font-size: max(18px, 1vw);\n    line-height: 1.3;\n    color: var(--darkblue);\n    margin-bottom: 15px;\n}\n.mt-50{\n    margin-top: 70px;\n}\n/* .delight-card.mt-50:hover{\n    transform: translateY(  0px);\n    transition: all ease 0.25s;\n} */\n\n.delight-card:hover .delight-img img {\n    transform: scale(1.025);\n    transition: all ease 0.25s;\n}\n\n.delight-img img {\n    transform: scale(1);\n    transition: all ease 0.25s;\n}\n\n.delight-slider .swiper-slide:nth-child(odd) {\n    margin-top: 70px;\n}\n\n/*==== footer classes ====*/\n.footer {\n    border-top: 1px solid #cccc;\n}\n.powerd-by {\n    /* display: flex; */\n    /* align-items: center; */\n}\n.powerd-by span {\n    /* margin-right: 10px; */\n    font-size: 16px;\n    font-weight: 400;\n}\n.footer-menu {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n.footer-menu li::after {\n    content: \"|\";\n    padding: 0 10px;\n}\n.footer-menu li {\n    list-style: none;\n}\n.footer-menu li:last-child::after {\n    display: none;\n}\n.footer-menu li a {\n    color: var(--darkblue);\n    text-transform: uppercase;\n}\n\n/*==== onboard modal classes ====*/\n.onboard-modal .btn-close {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n}\n.welcome-note {\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--darkblue);\n}\n.welcome-para {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n.welcome-para span{\n    color: #FF7020;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 24px;\n}\n.onboard-modal .modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    margin: auto;\n    pointer-events: auto;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0,0,0,.2);\n    border-radius: 0.5rem;\n    outline: 0;\n}\n.onboard-modal button, .onboard-modal a{\n    box-shadow: none!important;\n}\n.rdeem-progress {\n    width: 100%;\n    background: #ccc;\n    position: relative;\n    border-radius: 100px;\n    margin: 40px 0px;\n    display: flex;\n    align-items: center;\n    /* overflow: hidden; */\n    height: 8px;\n}\n.progress-left {\n    background: var(--orange);\n    height: 100%;\n    border-radius: 100px 0  0 100px;\n    position: relative;\n}\n.progress-left span {\n    position: absolute;\n    top: -25px;\n}\n.progress-left span:first-child {\n    left: 0;\n}\n.progress-left span:last-child {\n    right: 0;\n}\n.progress-right {\n    background: var(--blue);\n    height: 8px;\n    position: relative;\n    border-radius: 0 100px 100px 0;\n    margin-left: auto;\n}\n.progress-right span {\n    position: absolute;\n    top: -35px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: #ece9fc;\n    font-size: 12px;\n    width: max-content;\n    padding: 5px;\n    color: var(--blue);\n    border-radius: 2px;\n}\n.progress-right span::after {\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    background: #ece9fc;\n    position: absolute;\n    z-index: -1;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    bottom: 0;\n}\n\n/*==== gift-card listing classes ====*/\n\n.back-to-btn {\n    color: #f1f1f1;\n    transition: all ease 0.3s;\n    position: absolute;\n    top: 8px;\n}\n.back-to-btn:hover{\n    color: #fff;\n    transition: all ease 0.3s;\n}\n.custom-select {\n    position: relative;\n}\n.select-label {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: fit-content;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #7E858E;\n}\n.custom-select .form-select {\n    height: 40px;\n    /* border-radius: 2px; */\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #7E858E;\n}\n.custom-select .form-select:focus{\n    box-shadow: none;\n    border: 1px solid var(--blue);\n}\n/* .product-filters .search-bar {\n    max-width: unset;\n} */\n.fw-semi{\n    font-weight: 500!important;\n}\n.product-categories .product-block {\n    margin-right: 15px;\n}\n.product-categories .product-block span {\n    background: transparent;\n    color: var(--darkblue);\n    border: 1px solid #ccc;\n}\n.search-bar .form-control:focus {\n    box-shadow: none;\n    border-color: var(--blue);\n}\n.select2-container--default .select2-selection--single {\n    height: 40px;\n    padding-top: 5px;\n    border: 1px solid #D7dfe9;\n}\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--single, .select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {\n    border: 1px solid var(--blue);\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    top: 7px;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n    border-width: 0px;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b::after {\n    content: \"\\f078\";\n    font-family: 'font awesome 5 pro';\n    position: absolute;\n    transition: all ease 0.3s;\n    font-size: 14px;\n    color: var(--darkblue);\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b::after {\n    transform: rotate(180deg);\n    transition: all ease 0.3s;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    top: 0px;\n    right: 10px;\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n    border-width: 0;\n}\n.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable{\n    background: #F5F7FA;\n    color: var(--darkblue);\n}\n.select2-container--default .select2-results__option--selected{\n    background: #F5F7FA;\n    color: var(--darkblue);\n    opacity: 0.85;\n}\n.category-btn.text-dark:hover {\n    color: var(--blue) !important;\n}\n.select2-container--default .select2-search--dropdown .select2-search__field:focus {\n    border-color: var(--blue);\n    outline: none;\n}\n.select2-results__option {\n    -webkit-user-select: none;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #7E858E;\n}\n.product-block.active span{\n    background: var(--darkblue);\n    color: #fff;\n    border-color: var(--darkblue)!important;\n}\n.select2-container {\n    width: 100% !important;\n}\n\n\n.listing-block {\n    background: #FFFFFF;\n    border: 1px solid #D7DFE9;\n    border-radius: 16px;\n    padding: 25px;\n    height: 95%;\n}\n.listing-top-left {\n    display: flex;\n}\n.listing-logo {\n    width: 73px;\n    height: 65px;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n    border: 1px solid #D7DFE9;\n    border-radius: 5px;\n    padding: 7px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n}\n.listing-name {\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n.listing-categorydtl {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #7E858E;\n    margin-top: 5px;\n}\n.view-listing-btn {\n    font-weight: 700;\n    font-size: 11px;\n    line-height: 16px;\n    max-width: 130px;\n    letter-spacing: 0.01em;\n    text-transform: uppercase;\n    color: #7E858E;\n    text-align: center;\n}\n.responsive_text{\n  margin-top: 8px;\n  font-size: 13px;\n  font-weight: 500;\n}\n.listing-top {\n    margin-bottom: 25px;\n}\n.listing-bottom-left {\n    display: flex;\n    flex-direction: column;\n}\n\n.listing-input {\n    display: flex;\n    align-items: center;\n}\n.listing-input-btn {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #D9D9D9;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.listing-input-btn:hover {\n    border: 1px solid #D9D9D9;\n}\n.listing-input-btn svg {\n    height: 25px;\n    width: 25px;\n    transform: scale(1.5);\n}\n.inputwithunit {\n    position: relative;\n}\n.inputwithunit span {\n    position: absolute;\n    left: 8px;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 32px;\n    text-align: center;\n    color: #171F46;\n    top: 50%;\n    transform: translateY(-50%);\n}\n.inputwithunit .form-control {\n    padding-left: 5px;\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #171F46;\n   width: 74px;\n    padding-left: 20px;\n}\n.listing-bottom-right span {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    /* line-height: 8px; */\n    color: var(--blue);\n}\n.listing-bottom-right{\n    margin-left: 23px;\n  \n}\n.listing-bottom-right h6 {\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 22px;\n   \n    color: var(--blue);\n}\n.listing-bottom-right h6 span{\n    font-size: 24px!important;\n    line-height: 32px;\n}\n.listing-bottom-right {\n    text-align: center;\n}\n.listing-bottom-right h6 {\n    margin: 5px auto;\n    width: fit-content;\n}\n.listing-logo img {\n    max-width: 50px;\n}\ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n  -webkit-appearance: none; \n  margin: 0; \n}\ninput[type=number] {\n    -moz-appearance:textfield;\n}\n\n\n.checkout-left h5 {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n}\n.checkout-left h5:nth-child(1) {\n    color: var(--orange);\n}\n.checkut_Funds_used {\n    color: var(--orange);\n}\n.checkout-left h5:nth-child(2) {\n    color: var(--darkblue);\n}\n.checkout-Remaining{\n    color: var(--darkblue);\n}\n.checkout-left h5:nth-child(3) {\n    color: var(--blue);\n}\n.checkout_bonus {\n    color: var(--blue);\n}\n.checkout_bonus_cash {\n    color: var(--yellow);\n}\n\n.chekout-toggle {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #D7dfe9;\n    border-radius: 100%;\n    position: absolute;\n    top: -20px;\n    background: #fff;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.new-chekout-toggle {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #D7dfe9;\n    border-radius: 100%;\n    position: absolute;\n    top: 50%;\n    left: -1%; /* Adjust the left positioning as needed */\n    transform: translateX(-50%);\n    background: #fff;\n    z-index: 1; /* Ensure it's above other content */\n}\n\n.promotional_toggle{\n    width: 35px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #D7dfe9;\n    border-radius: 100%;\n    position: absolute;\n    top: -24px;\n    z-index: 1;\n    background: #fff;\n    left: 50%;\n    transform: translate(-50%,-0%);  \n}\n\n\n.brands_toggle{\n    width: 35px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #D7dfe9;\n    border-radius: 100%;\n    /* position: absolute; */\n    top: 80px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    z-index: 2;\n    background: #fff;\n    right: 1%;\n    transform: translate(-50%,-0%);  \n}\n\n\n.brands_toggle svg {\n    transform: rotate(0deg);\n    transition: all ease 0.5s;\n}\n.brands_toggle.rotate svg {\n    transform: rotate(180deg);\n    transition: all ease 0.5s;\n}\n\n.mobView-toggle{\n    width: 35px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #D7dfe9;\n    border-radius: 100%;\n    position: absolute;\n    /* margin-top:10px; */\n    background: #fff;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.go-checkout {\n    bottom: calc(0% - 85px);\n    transition: all ease 1s;\n\n}\n.go-checkout-length-1 {\n    bottom: calc(0% - 185px);\n}\n\n.go-checkout-length-2 {\n    bottom: calc(0% - 200px);\n}\n\n.go-checkout-default {\n    bottom: calc(0% - 150px);\n}\n.go-checkout.active {\n    bottom: 0;\n    transition: all ease 0.5s;\n}\n.go-checkout.notable{\n    bottom: 0;\n}\n.chekout-toggle.rotate i, .chekout-toggle.rotate svg {\n    transform: rotate(180deg);\n    transition: all ease 0.5s;\n}\n.chekout-toggle i, .chekout-toggle svg {\n    transform: rotate(0deg);\n    transition: all ease 0.5s;\n}\n\n\n.promotional_toggle svg {\n    transform: rotate(0deg);\n    transition: all ease 0.5s;\n}\n.promotional_toggle.rotate svg {\n    transform: rotate(180deg);\n    transition: all ease 0.5s;\n}\n.mobView-toggle.rotate i, .mobView-toggle.rotate svg{\n    transform: rotate(180deg);\n    transition: all ease 0.5s;\n}\n.mobView-toggle i, .mobView-toggle svg {\n    transform: rotate(0deg);\n    transition: all ease 0.5s;\n}\n.hide_class{\nopacity: 0;\ntransition: 0.9s;\ndisplay: none;\n\n}\n.product-listing {\n    /* padding-bottom: 140px; */\n}\n.chekout-middle-table .table .btn {\n    font-size: 12px;\n}\n.chekout-middle-table .table {\n    font-size: 12px;\n    color: #7E858E;\n}\n.chekout-middle-table .table thead tr th {\n    font-weight: 400;\n    color: var(--darkblue);\n}\n.table > :not(:last-child) > :last-child > * {\n    border-bottom-width: 0px;\n}\n.table>:not(:first-child) {\n    border-top-width: 0px;\n}\n/* .category-modal .category-block:hover {\n    border: 1px solid var(--darkblue);\n} */\n.categories-mtitle {\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--darkblue);\n}\n.listing-block.highlight::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    /* background: #0000005e; */\n    left: 0;\n    top: 0;\n    z-index: -1;\n    background: #fff;\n    border-radius: 10px;\n}\n.listing-block.highlight::after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    background: #00000087;\n    left: 0;\n    top: 0;\n    z-index: -2;\n}\n.listing-block.highlight {\n    position: relative;\n    z-index: 9999;\n}\n\n.onboard-step {\n    position: absolute;\n    margin-top: 15px;\n    background: #fff;\n    border-radius: 5px;\n    padding: 20px 20px;\n}\n.onboard-step.step-1 {\n    width: calc(100% + 227px);\n    left: -75px;\n    max-width: 600px;\n    top: calc(100% + 10px);\n}\n.onboard-header h3 {\n    color: var(--darkblue);\n    font-weight: 600;\n    font-size: max(20px, 1.5vw);\n}\n.onboard-close-btn {\n    width: 30px;\n    height: 30px;\n    padding: 7px;\n    background: #3333;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n}\n.onboard-close-btn:hover{\n    color: #333;\n}\n.onboard-middle p {\n    line-height: 1.57;\n}\n.onboard-paginate span {\n    width: 10px;\n    height: 10px;\n    background: #777;\n    border-radius: 100%;\n    margin: 0px 12px;\n    /* cursor: pointer; */\n}\n.onboard-paginate span.active {\n    background: var(--orange);\n    /* cursor: not-allowed; */\n}\n.onboard-step.step-1::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    top: 0px;\n    transform: rotate(45deg) translateX(-50%);\n    left: 50%;\n    border-radius: 5px;\n}\n/* .onboard-step.step-2 {\n    top: -130px;\n    max-width: 500px;\n    width: 428px;\n    left: -716%;\n    transform: translateX(-50%);\n    box-shadow: 0px 0px 5px 0px #3333331c;\n} */\n.onboard-step.step-2 {\n    top: 50%;\n    width: 400px;\n    right: calc(100% + 25px);\n    box-shadow: 0px 0px 5px 0px #3333331c;\n    transform: translateY(-50%);\n}\n/* .onboard-step.step-2::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    transform: rotate(45deg) translateX(-50%);\n    left: 99%;\n    border-radius: 5px;\n    bottom: 80px;\n    box-shadow: 8px 0px 0px 0px #33333314;\n} */\n.onboard-step.step-2::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    transform: rotate(45deg)translateY(-50%);\n    left: calc(100% - 27px);\n    border-radius: 5px;\n    box-shadow: 8px 0px 0px 0px #33333314;\n    top: calc(50% - 17px);\n}\n.go-checkout.highlight::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #00000087;\n    left: 0;\n    top: 0;\n    position: fixed;\n    z-index: -2;\n}\n.go-checkout.highlight::after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    left: 0;\n    top: 0;\n    position: absolute;\n    z-index: -1;\n}\n/* .onboard-step.step-3 {\n    top: -171px;\n    max-width: 500px;\n    right: 73px;\n    box-shadow: 0px 0px 5px 0px #3333331c;\n    width: calc(100% + 400px);\n}\n.onboard-step.step-3::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    transform: rotate(45deg) translateX(-50%);\n    left: 99%;\n    border-top:1px solid black;\n    border-right:1px solid black;\n    border-radius: 5px;\n    bottom: -5px;\n    box-shadow: 8px 7px 8px 0px #33333314;\n} */\n\n.onboard-step.step-3 {\n    right: 50%;\n    max-width: 300px;\n    top: unset;\n    position: fixed;\n    transform: translate(50%, -50%);\n    bottom: 65px;\n    width: 280px;\n    background-color: #fff;\n    /* backdrop-filter: blur(4px); */\n}\n\n@media only screen and (min-width: 768px) {\n    .onboard-step.step-3 {\n        background-color: #ffffff;\n        \n    }\n    /* .onboard-step.step-3::before {\n        display: none!important;\n    } */\n}\n\n.btn_arrow_check {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.onboard-step.step-3::before {\n    bottom: unset;\n    left: 50%;\n    top: calc(100% + -4px);\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    border-top: 0;\n    border-radius: 0 0 5px 0;\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    transform: rotate(45deg) translateX(-50%);\n    box-shadow: 8px 7px 8px 0px #33333314;\n}\n\n/*==== checkout page classes ====*/\n.checkout-left-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.chekcout-filters ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n.chekcout-filters ul li {\n    list-style: none;\n    margin-left: 15px;\n}\n.chekcout-filters ul li a {\n    color: var(--color);\n}\n.chekcout-filters ul li a:hover, .chekcout-filters ul li a.active{\n    color: var(--darkblue);\n\n}\n.checkout-table thead::before {\n    border: 1px solid #3333;\n    border-radius: 5px 5px 0 0;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: -1;\n}\n.checkout-table thead {\n    position: relative;\n}\n.checkout-table thead tr th {\n    padding: 15px 25px;\n    font-size: 14px;\n    text-transform: uppercase;\n    color: var(--color);\n    font-weight: 500;\n}\n.checkout-table thead tr th .btn {\n    margin-left: 7px;\n    color: var(--color);\n}\n.checkout-table thead tr th .btn:hover{\n    color: #333;\n}\n.checkout-table tbody tr td {\n    padding: 15px 25px;\n    vertical-align: middle;\n    font-size: 14px;\n    color: var(--color);\n}\n.gift-logo {\n    width: 50px;\n    height: 44px;\n    border: 2px solid #D7DFE9;\n    border-radius: 4px;\n    margin-right: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 50px;\n}\n.gift-logo img {\n    width: 100%;\n    height: 100%;\n    /* object-fit: cover; */\n}\n.checkout-table tbody tr td .btn {\n    color: var(--color);\n}\n.checkout-table tbody tr td .btn:hover {\n    color: #333;\n}\n.checkout-left-header h3 {\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--darkblue);\n}\n.return-btn {\n    color: var(--color);\n    font-weight: 400;\n    text-transform: uppercase;\n    font-size: 13px;\n}\n.return-btn:hover{\n    color: var(--darkblue);\n}\n.progress-labels {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n}\n.pblock-icon {\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    margin-right: 7px;\n}\n.pblock-label {\n    display: flex;\n    align-items: center;\n    margin-right: 15px;\n}\n.checkout-rightp {\n    min-height: 100vh;\n}\n.text-orange{\n    color: var(--orange);\n}\n.redeem-alert {\n    background: #FFF3F5;\n    border: 1px solid #FF0B37;\n    border-radius: 5px;\n    display: flex;\n}\n.ralert-con {\n    color: #FF0B37;\n    font-size: 24px;\n}\n.ralert-content {\n    margin: 0 15px;\n    color: #FF0B37;\n}\n.ralert-content h6 {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 7px;\n}\n.ralert-content p {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n}\n.ralert-btn {\n    border: 1px solid #FF0B37;\n    border-radius: 999px;\n    color: #FF0B37;\n    padding: 3px 16px;\n    font-size: 15px;\n    font-weight: 500;\n    transition: all ease 0.3s;\n}\n.ralert-btn:hover{\n    background: #FF0B37;\n    color: #fff;\n    transition: all ease 0.3s;\n}\n.checkout-right-bottom h5 {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n}\n.checkout-table thead tr th .btn.active i {\n    transform: rotateX(180deg);\n    transition: all ease 0.3s;\n}\n.checkout-table thead tr th .btn i {\n    transform: rotateX(0deg);\n    transition: all ease 0.3s;\n}\n\n/*==== All Brands classes ====*/\n\n.allbrands-head {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--darkblue);\n    text-align: center;\n}\n\n.progress-left.prg_middle span {\n    top: 12px;\n}\n\n/*==== payout confirmation classes ====*/\n\n.confetti {\n    position: absolute;\n    padding: 2.2em 1.8em;\n    width: 100%;\n    overflow: hidden;\n    min-height: 100vh;\n    z-index: -1;\n}\n\n.confetti-piece {\n  position: absolute;\n  width: 8px;\n  height: 16px;\n  background: #ffd300;\n  top: 0;\n  opacity: 0;\n}\n.confetti-piece:nth-child(1) {\n  left: 7%;\n  transform: rotate(-74deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 107ms;\n          animation-delay: 107ms;\n  -webkit-animation-duration: 1188ms;\n          animation-duration: 1188ms;\n}\n.confetti-piece:nth-child(2) {\n  left: 14%;\n  transform: rotate(-71deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 334ms;\n          animation-delay: 334ms;\n  -webkit-animation-duration: 886ms;\n          animation-duration: 886ms;\n}\n.confetti-piece:nth-child(3) {\n  left: 21%;\n  transform: rotate(24deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 42ms;\n          animation-delay: 42ms;\n  -webkit-animation-duration: 814ms;\n          animation-duration: 814ms;\n}\n.confetti-piece:nth-child(4) {\n  left: 28%;\n  transform: rotate(-42deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 124ms;\n          animation-delay: 124ms;\n  -webkit-animation-duration: 710ms;\n          animation-duration: 710ms;\n}\n.confetti-piece:nth-child(5) {\n  left: 35%;\n  transform: rotate(24deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 39ms;\n          animation-delay: 39ms;\n  -webkit-animation-duration: 985ms;\n          animation-duration: 985ms;\n}\n.confetti-piece:nth-child(6) {\n  left: 42%;\n  transform: rotate(3deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 113ms;\n          animation-delay: 113ms;\n  -webkit-animation-duration: 727ms;\n          animation-duration: 727ms;\n}\n.confetti-piece:nth-child(7) {\n  left: 49%;\n  transform: rotate(31deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 196ms;\n          animation-delay: 196ms;\n  -webkit-animation-duration: 895ms;\n          animation-duration: 895ms;\n}\n.confetti-piece:nth-child(8) {\n  left: 56%;\n  transform: rotate(-20deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 44ms;\n          animation-delay: 44ms;\n  -webkit-animation-duration: 844ms;\n          animation-duration: 844ms;\n}\n.confetti-piece:nth-child(9) {\n  left: 63%;\n  transform: rotate(2deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 129ms;\n          animation-delay: 129ms;\n  -webkit-animation-duration: 707ms;\n          animation-duration: 707ms;\n}\n.confetti-piece:nth-child(10) {\n  left: 70%;\n  transform: rotate(35deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 39ms;\n          animation-delay: 39ms;\n  -webkit-animation-duration: 813ms;\n          animation-duration: 813ms;\n}\n.confetti-piece:nth-child(11) {\n  left: 77%;\n  transform: rotate(-63deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 447ms;\n          animation-delay: 447ms;\n  -webkit-animation-duration: 791ms;\n          animation-duration: 791ms;\n}\n.confetti-piece:nth-child(12) {\n  left: 84%;\n  transform: rotate(13deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 479ms;\n          animation-delay: 479ms;\n  -webkit-animation-duration: 888ms;\n          animation-duration: 888ms;\n}\n.confetti-piece:nth-child(13) {\n  left: 91%;\n  transform: rotate(-38deg);\n  -webkit-animation: makeItRain 1000ms infinite ease-out;\n          animation: makeItRain 1000ms infinite ease-out;\n  -webkit-animation-delay: 226ms;\n          animation-delay: 226ms;\n  -webkit-animation-duration: 1042ms;\n          animation-duration: 1042ms;\n}\n.confetti-piece:nth-child(odd) {\n  background: #17d3ff;\n}\n.confetti-piece:nth-child(even) {\n  z-index: 1;\n}\n.confetti-piece:nth-child(4n) {\n  width: 5px;\n  height: 12px;\n  -webkit-animation-duration: 2000ms;\n          animation-duration: 2000ms;\n}\n.confetti-piece:nth-child(3n) {\n  width: 3px;\n  height: 10px;\n  -webkit-animation-duration: 2500ms;\n          animation-duration: 2500ms;\n  -webkit-animation-delay: 1000ms;\n          animation-delay: 1000ms;\n}\n.confetti-piece:nth-child(4n-7) {\n  background: #ff4e91;\n}\n\n@-webkit-keyframes makeItRain {\n  from {\n    opacity: 0.2;\n  }\n  50% {\n    opacity: 1;\n  }\n  to {\n    transform: translateY(200px);\n  }\n}\n\n@keyframes makeItRain {\n  from {\n    opacity: 0.2;\n  }\n  50% {\n    opacity: 1;\n  }\n  to {\n    transform: translateY(200px);\n  }\n}\n\n.pconfirmation-area {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: max(700px, 90vh);\n    text-align: center;\n}\n.cngt-title {\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--darkblue);\n}\n.cngta-block h2 {\n    font-weight: 700;\n    font-size: 80px;\n    line-height: 88px;\n}\n.text-blue{\n    color: var(--darkblue);\n}\n.cngta-block p {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n.recvupdate {\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--darkblue);\n}\n.cngt-btns .btn {\n    max-width: 356px;\n}\n.cngt-btns .btn {\n    max-width: 356px;\n    display: block;\n    margin: 40px auto;\n}\n.cngt-btns .btn {\n    max-width: 356px;\n    display: block;\n    margin: 30px auto;\n    border-radius: 999px;\n    font-size: 14px;\n}\n.otherp-btn {\n    padding: 8px 16px;\n    color: var(--darkblue);\n}\n.cngt-vs h4 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.go-checkout.empty {\n    bottom: calc(0% - 60px);\n}\n\n.paginationsearch:focus{\n\n    outline: none;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n\n}\n\n/* .business-dash{\n    text-align: center;\n    margin: 2px;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n} */\n.cart-count {\n    position: absolute;\n    top: -12px;\n    right: -2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    background-color: var(--newMainBlue);\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .nav-cart{\n    position: relative;\n    cursor: pointer;\n  }\n  .welcome-img-business{\n    overflow: hidden;\n    min-height: 309px;\n    position: relative;\n    z-index: 0;\n  }\n  .welcome-img-business > img {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: auto;\n    /* object-fit: cover; */\n\n  }\n  .coinImg{\n    width: 110px;\n    height: 90px;\n    margin: auto;\n  }\n  .customerDot{\n   min-height: 20px;\n    min-width: 20px;\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #2665F2;\n  }\n  .customerDotactive{\n    min-height: 20px;\n    min-width: 20px;\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #65B5FF;\n  }\n\n  .bigCirclePie{\n    margin-top: 15px;\n    align-items: center;\n    display: flex;\n    max-width: 170px;\n     height: 170px;\n     border-radius: 50%;\n     border: 10px solid #FF7020;\n  }\n  .smallCirclePie{\n    width: 60%;\n    height: 60%;\n    border-radius: 50%;\n    background-color: #65B5FF;\n    text-align: center;\n    margin: auto;\n    position: absolute;\n    top: 50%;\n    right: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: translate(50%, -50%);\n  }\n \n\n\n\n\n  .progress_body {\n    width: 100%;\n    height: 10px;\n    border-radius: 28px;\n    background-color: #747373;\n}\n\n.progres {\n    cursor: pointer;\n    border: none;\n    height: 10px;\n    background-color: #ff5300;\n    position: relative;\n}\n\n.progres:nth-child(1){\n    border-radius: 28px 0px 0px 28px;\n}\n\n.progres:nth-child(1)>span {\n    display: none;\n}\n\n.progres:nth-child(1):hover>span {\n    display: block;\n}\n\n.progres:nth-child(1)>span,\n.progres:nth-child(1):hover>span {\n    position: absolute;\n    left: 50%;\n    top: -187%;\n    background-color: #ff5300;\n    transform: translate(-50%, -50%);\n    padding: 5px;\n    color: #fff;\n    font-size: 10px;\n    z-index: 2;\n}\n\n\n.progres:nth-child(1)>span+span {\n    display: none;\n}\n\n.progres:nth-child(1):hover>span+span {\n    display: block;\n}\n\n.progres:nth-child(1)>span+span,\n.progres:nth-child(1):hover>span+span {\n    z-index: 1;\n    content: '';\n    position: absolute;\n    width: 0px;\n    height: 0px;\n    bottom: 50%;\n    transform: rotate(45deg) translate(-17%, 66%);\n    left: 50%;\n    background-color: #ff5300;\n}\n\n\n\n\n\n\n\n.progres:nth-child(2)>span {\n    display: none;\n}\n\n.progres:nth-child(2):hover>span {\n    display: block;\n}\n\n.progres:nth-child(2)>span,\n.progres:nth-child(2):hover>span {\n    position: absolute;\n    left: 49%;\n    bottom: -30px;\n    background: green;\n    transform: translate(-50%, 0px);\n    padding: 5px;\n    font-size: 10px;\n    color: #fff;\n    z-index: 2;\n}\n\n\n.progres:nth-child(2)>span+span {\n    display: none;\n}\n\n.progres:nth-child(2):hover>span+span {\n    display: block;\n}\n\n.progres:nth-child(2)>span+span,\n.progres:nth-child(2):hover>span+span {\n    z-index: 1;\n    content: '';\n    position: absolute;\n    width: 0px;\n    height: 0px;\n    bottom: -12px;\n    transform: rotate(45deg) translate(-17%, 7px);\n    left: 50%;\n    background-color: green;\n\n}\n\n\n\n\n\n.progres:nth-child(3)>span {\n    display: none;\n}\n\n.progres:nth-child(3):hover>span {\n    display: block;\n}\n\n.progres:nth-child(3)>span,\n.progres:nth-child(3):hover>span {\n    position: absolute;\n    left: 50%;\n    top: -187%;\n    background-color: rgb(128, 98, 0);\n    transform: translate(-50%, -50%);\n    padding: 5px;\n    color: #fff;\n    font-size: 10px;\n    z-index: 2;\n}\n\n\n.progres:nth-child(3)>span+span {\n    display: none;\n}\n\n.progres:nth-child(3):hover>span+span {\n    display: block;\n}\n\n.progres:nth-child(3)>span+span,\n.progres:nth-child(3):hover>span+span {\n    z-index: 1;\n    content: '';\n    position: absolute;\n    width: 0px;\n    height: 0px;\n    bottom: 50%;\n    transform: rotate(45deg) translate(-17%, 66%);\n    left: 50%;\n    background-color: rgb(128, 98, 0);\n}\n\n\n\n\n\n\n\n.progres:nth-child(4)>span {\n    display: none;\n}\n\n.progres:nth-child(4):hover>span {\n    display: block;\n}\n\n.progres:nth-child(4)>span,\n.progres:nth-child(4):hover>span {\n    position: absolute;\n    left: 49%;\n    bottom: -30px;\n    background: rgb(0, 87, 128);\n    transform: translate(-50%, 0px);\n    padding: 5px;\n    font-size: 10px;\n    color: #fff;\n    z-index: 2;\n}\n\n\n.progres:nth-child(4)>span+span {\n    display: none;\n}\n\n.progres:nth-child(4):hover>span+span {\n    display: block;\n}\n\n.progres:nth-child(4)>span+span,\n.progres:nth-child(4):hover>span+span {\n    z-index: 1;\n    content: '';\n    position: absolute;\n    width: 0px;\n    height: 0px;\n    bottom: -12px;\n    transform: rotate(45deg) translate(-17%, 7px);\n    left: 50%;\n    background-color: rgb(0, 87, 128);\n\n}\n\n.fixed_style{\n    width: 100%;\n}\n.progress_body {\n    display: flex;\n}\n\n.task-progress {\n    margin: 35px 0px ;\n    display: flex;\n    align-items: center;\n}\n.proItem .col-lg-3.col-md-6 {\n    width: 100%!important;\n    height: 10% !important\n}\n\n/* @media screen and (min-width:690px) and (max-width:992px){\n    .proItem .col-lg-3.col-md-6 {\n       width: 75% !important;\n    }\n\n} */\n/* @media screen and (min-width:1640px) {\n    .proItem .col-lg-3.col-md-6 {\n        width: 76%!important;\n        height: 10% !important\n    }\n} */\n.toggle_button{\n    position: absolute;\n    bottom:-16px;\n   }\n   .show_box{\n    transition: 0.5s;\n    margin-top: -140px !important;\n   }\n   .hide_box{\n    margin-top: 0px !important;\n    transition: 0.5s;\n   }\n\n   @media screen and (min-width:425.98px) and (max-width:576px){\n    .show_box{\n        margin-top: -160px !important;\n    }\n   }\n   @media screen and (max-width:425px) {\n    .show_box{\n        margin-top: -205px !important;\n    }\n   }\n   @media screen and (max-width:324px){\n    .show_box{\n        margin-top: -252px !important;\n    }\n   }\n@media screen and (max-width:425px){\n    \n   .go-category{\n    bottom: calc(0% - 85px);\n    transition: all ease 0.5s;\n   }\n   .go-category.active{\n    bottom: 0;\n    transition: all ease 0.5s;\n   }\n   .go-category.notable{\n    bottom: 0;\n   }\n   .go-category.highlight::before{\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #00000087;\n    left: 0;\n    top: 0;\n    position: fixed;\n    z-index: -2;\n   }\n   .go-category.highlight::after{\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    left: 0;\n    top: 0;\n    position: absolute;\n    z-index: -1;\n   }\n   .go-category.empty{\n    bottom: calc(0% - 60px);\n   }\n   .mobile_category{\n    margin: 0px 0px !important;\n   }\n\n}\n@media screen and (min-width:992px) and (max-width:2600px){\n    .go-category{\n     margin-bottom: -14px !important;\n    }\n}\n@media screen  and (min-width:992px) and (max-width:1199.98px) {\n    .listing-input-btn {\n        padding: 3px;\n        width: 26px;\n        height: 25px;\n    }\n    .listing-input-btn svg {\n        height: 11px !important;\n        width: 11px !important;\n        transform: scale(1) !important;\n    }\n\n    .inputwithunit .form-control{\n        line-height: 20px;\n    }\n    .listing-bottom-right{\n        margin-left: 0px;\n    }\n    .listing-bottom-right h6 {\n        font-size: 15px !important;\n    }\n    .dropdown_listing{\n        font-size: 16px !important;\n        line-height: 22px !important;\n    }\n    .listing-name {\n     min-height: 48px;\n    }\n    .responsive_text{\n        font-size: 12px;\n        margin-top: 0px;\n    }\n    .listing-block{\n        height: 98% !important;\n    }\n    \n    .view-listing-btn{\n        line-height: 7px;\n        margin-top: -20px;\n    }\n}\n@media screen  and (min-width:1200px){\n    .left_bottom_div{\n        margin-left: 0px;\n    }\n}\n@media screen and (max-width:576px){\n    /* .dropdown_listing{\n        max-width: 47% !important;\n        \n    } */\n    \n}\n\n@media screen  and (max-width:576px){\n    .first_div{\n        margin: 0px auto !important;\n    }\n    .second_div{\n        margin: 0px auto !important;\n    }\n   \n}\n\nlisting_logo_img {\n    width: 100%;\n    max-width: 200px !important;\n    height: 34px;\n    border-radius: 2px;\n}\n.listing-logo {\n    width: 66px;\n    height: 56px;\n}\n\n.first_div{\n    width: 150px;\n    /* margin: 0px auto !important; */\n}\n.second_div{\n    width: 150px;\n    margin-top: 7px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.second_div a.add_button_New {\n    width: 75px;\n    margin: 0  !important;\n}\n\n.proItem .main_div.active{\ndisplay: flex;\nflex-direction: column;\njustify-content: end;\nalign-items: center;\nmargin-right: 0px !important;\n/* margin-top: 22px; */\n}\n@media screen and (max-width:425px){\n    .proItem .main_div.active{\n        margin-left: 0px !important;\n    }\n}\n.main_div.active{\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n    align-items: center;\n    }\n\n/* @media screen  and (max-width:576px){\n    \n    .button_dropdown{\n        margin-left: 8px !important;\n    }\n} */\n/* @media screen and (min-width:768px) and (max-width:1199.98px){\n    .button_dropdown{\n        margin-left: 28px !important;\n    }\n} */\n/* @media screen and (min-width:1200px) and (max-width:1399.99px){\n  .button_dropdown{\n    margin-left: 17px !important;\n}\n  } */\n\n@media screen and (min-width:992px) and (max-width:1199.99px){\n    .second_div a.add_button_New{\n        width: 75px;\n        margin-left: -13px !important;\n    }\n}\n/* @media screen and (max-width:1400px){\n    .add_button_New{\n        margin-left: 3px;\n    }\n} */\n/* .swiper.swiper-initialized{\nmargin: 20px !important;\n} */\n\n\n.listing-bottom-right-giftcards span {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--blue);\n}\n.listing-bottom-right-giftcards h6 {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 32px;\n    display: flex;\n    align-items: center;\n    color: var(--blue);\n}\n.listing-bottom-right-giftcards h6 span{\n    font-size: 24px!important;\n    line-height: 32px;\n}\n.listing-bottom-right-giftcards {\n    text-align: center;\n}\n.listing-bottom-right-giftcards h6 {\n    margin: 5px auto;\n    width: fit-content;\n}\n\n\n.Toastify__toast-body{\n font-family: var(--font-family) ;\n}\n\n\n\n/* PDF SCROLL */\n/* .customer-modal{\n    width: 100%;\n     height: 350px;\n     overflow-y:'auto';\n} */\n\n.custom-modal {\n    max-width: 350px; \n    margin: 0 auto; \n  }\n\n.position_relative{\n    overflow-y: auto;\n    overflow: hiden;\n/* max-width: 350px; */\nheight: 400px;\n}\n  .pdf-viewer-container {\n    width: 100%;\n    /* height: 800px; */\n    zoom: 100%;\n  }\n  \n  @media screen and (max-width: 600px) {\n    .pdf-viewer-container {\n      width: 100%;\n      /* height: 400px; */ \n      zoom: 100%;\n    }\n    .custom-modal {\n        max-width: 400px; \n        margin: 0 auto; \n      }\n      .position_relative{\n        /* overflow-y: auto; */\n        /* overflow: hiden; */\n    /* max-width: 400px; */\n    /* max-height: 349px; */\n    }\n  }\n\n  @media screen and (min-width:1550px) and (max-width:2000px) {\n    .pdf-viewer-container {\n        width: 100%;\n        height: 400px;\n        zoom: 100%;\n      }\n      .custom-modal {\n          max-width: 500px !important; \n          max-height: 700px !important;\n          margin: 0 auto; \n        }\n        .position_relative{\n          overflow-y: auto;\n          overflow: hiden;\n      /* max-width: 480px; */\n      max-height: 450px;\n      }\n  }\n  \n  @media screen and (min-width: 601px) and (max-width: 1200px) {\n    .pdf-viewer-container {\n      width: 100%;\n      /* height: 350px; */\n      zoom: 100%; \n    }\n    .custom-modal {\n        max-width: 350px; \n        margin: 0 auto; \n      }\n  }\n  \n  @media screen and (min-width: 993px) and (max-width: 1200px) {\n    .pdf-viewer-container {\n      width: 100%;\n      /* height: 350px;  */\n      zoom: 100%;\n    }\n    .custom-modal {\n        max-width: 350px; \n        margin: 0 auto; \n      }\n    \n  }\n\n  @media screen and (min-width: 1201px) {\n    .pdf-viewer-container {\n      width: 100%;\n      /* height: 350px; */\n      zoom: 100%;\n    }\n    .custom-modal {\n        max-width: 350px; \n        margin: 0 auto; \n      }\n  }\n  \n\n\n/* \n  .scroll-modal::-webkit-scrollbar {\n    width: 5px;\n    height: 4px;\n  }\n  .scroll-modal::-webkit-scrollbar-thumb {\n    background-color: red;\n    border-radius: 6px;\n  }\n  .scroll-modal::-webkit-scrollbar-track {\n    background-color: transparent;\n  } */\n\n\n\n\n.product_select_box{\n    font-weight: bolder;\n    color: #000;\n    background-color: #fff;\n}\n  .product_select_box ul {\n    position: absolute;\n    top: 31px;\n    left: -11px;\n    width: 100%;\n    min-width: 81px;\n    padding: 2px;\n    background-color: #fff !important;\n    border: 1px solid gray;\n    border-radius: 5px;\n    font-weight: bolder;\n    color: #000;\n    z-index: 1;\n}\n.card_image_style{\n    height: 160px;\n    object-fit: cover;\n}\n.fixed-custom-footer-customer {\n    /* position: fixed; */\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background-color: #ffffff;\n}\n\n\n@media screen and (max-width: 15000px) and (min-width: 1200px) {\n    /* .customSearchMarginFooter{\n    margin-top: 618px;\n    }\n    .customCategoryMarginFooter{\n        margin-top: 300px;\n    } */\n}\n\n@media screen and (max-width: 1200px) and (min-width: 400px) {\n    .responsivePartner{\n        white-space: nowrap;\n    }\n}\n\n.customGap{\n    gap: 20px\n}\n@media screen and (max-width: 390px) {\n    .customGap{\n        gap: 12px\n    }\n}\n.listBox {\n  max-height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* scrollbar-width: thin; */\n  /* scrollbar-color: grey #eeeeee; */\n}\n\n.listBox::-webkit-scrollbar {\n  width: 5px;\n}\n\n.listBox::-webkit-scrollbar-track {\n  background: #eeeeee;\n}\n\n.listBox::-webkit-scrollbar-thumb {\n  background: grey;\n  border-radius: 5px;\n}\n.listBox::-webkit-scrollbar-button {\n  display: none;\n}\n.onBoardPromoMarginTop{\n    margin-top: 200px;\n}\nhtml, body {\n    width: 100%;\n    overflow-x: clip;\n}\n@media screen and (max-width: 992px) {\n    .onBoardPromoMarginTop{\n        margin-top: 350px;\n    }\n}\n@media screen and (max-width: 768px) {\n    .onBoardPromoMarginTop{\n        margin-top: 370px;\n    }\n}\n\n.checkout_offcanvas_content_onboard{\n   bottom: 0px !important;\n   /* top: auto !important; */\n   max-width: 400px ;\n   margin-top: 128px;\n   /* height: 86.60% !important; */\n   border: grey !important;\n   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;\n   position: invert-layer !important;\n   \n }\n .checkout_offcanvas_onboard {\n    bottom:0!important;\n    top:unset!important;\n  }\n  .offcanvas_body_onboard_height{\n      height: 65%;\n  }\n  .offcanvas_footer_onboard_height{\n      height: 35%;\n  }\n @media screen and  (min-width: 1200px){\n    .zoomScreenOnBoard{\n      zoom: 0.8;\n    }\n    .checkout_offcanvas_content_onboard{\n        max-width: 350px;\n        margin-top: 102px;\n    }\n    .offcanvas_body_onboard_height{\n        height: 49% !important;\n    }\n    .offcanvas_footer_onboard_height{\n        height: 51% !important;\n    }\n    .checkout_offcanvas_onboard {\n        height: calc(-132px + 100vh + 5.35%)!important;\n    }\n}\n @media screen and  (min-width: 1540px){\n    .zoomScreenOnBoard{\n      zoom: 100%;\n    }\n    .offcanvas_body_onboard_height{\n        height: 65% !important;\n    }\n    .offcanvas_footer_onboard_height{\n        height: 35% !important;\n    }\n    .checkout_offcanvas_onboard {\n        height: calc(-180px + 100vh + 5.35%)!important;\n    }\n    .checkout_offcanvas_content_onboard{\n        max-width: 400px;\n        margin-top: 129px;\n    }\n    \n}\n\n.custom_discount {\n    right: 0px;\n    top: 0px;\n    color: white;\n    cursor: pointer;\n    min-width: auto;\n    background-color: #68B942;\n    font-weight: bold;\n    border-bottom-left-radius: 15px;\n    border-top-right-radius: 1px;\n    z-index: 1;\n  }\n  .custom_discount:hover {\n    box-shadow: 0 1px 5px rgb(0, 0, 0);\n    font-weight: bold;\n}\n.custom_discount_promoBrand {\n    right: 0px;\n    top: 0px;\n    color: white;\n    cursor: pointer;\n    width: auto;\n    background-color: #68B942;\n    font-weight: bold;\n    border-top-right-radius: 15px;\n    border-bottom-left-radius: 15px;\n  }\n  .custom_discount_checkout {\n    right: -39px;\n    top: -17px;\n    color: white;\n    cursor: pointer;\n    min-width: 60px;\n    background-color: #68B942;\n    font-weight: bold;\n    font-size: 10px;\n}\n  .responsive_card_footer{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        flex-direction: row;\n  }\n  @media screen and (max-width: 550px){\n    .responsive_card_footer{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        gap: 10px;\n        /* margin: 0px 16px; */\n    }\n    .card-footer{\n        padding: 5px 0px 10px 0px;\n        \n    }\n    .inputwithunit .responsive_inputwithunit {\n        width: 80px;\n        \n    }\n    .inputwithunit .responsive_select_width  {\n        width: 134px;\n    }\n    .responsive_card_footer div:nth-child(2){\n       max-width: 100% !important;\n    }\n    /* .inputwithunit .responsive_dollar{\n        left: 40px \n    } */\n    .responsive_button_style{\n        font-size: 16px;\n        font-weight: bold;\n        padding: 55px;\n    }\n   \n}\n\n  .responsive_text_new_bonus{\n    color: rgb(245, 196, 0);\n    font-size: 12px ;\n}\n  @media screen and (max-width: 550px){\n    .responsive_button_style{\n        font-size: 16px;\n        font-weight: bold;\n        padding: 55px;\n    }\n    .responsive_text_new{\n        font-size: 15px;    \n    }\n    .responsive_text_new_bonus{\n        font-size: 14px ;\n        padding-left: 4px ;    \n    }\n  }\n\n  @media screen and (max-width: 475px){\n    .inputwithunit .responsive_inputwithunit {\n        width: 90px;\n        \n    }\n    .inputwithunit .responsive_select_width  {\n        width: 134px;\n    }\n  }\n  @media screen and (max-width: 490px){\n  }\n\n  .card_container_transaction {\n    max-width: 380px;\n    margin: 30px auto;\n    padding: 20px;\n    border-radius: 0.5rem;\n    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);\n}\n  .card_container_transaction_list {\n    max-width: 380px;\n    margin: 40px auto;\n    padding: 20px;\n    border-radius: 0.5rem;\n    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);\n}\n.card_container_transaction .header, .card-container .content {\n    margin-bottom: 1rem;\n}\n.custom_status_tag{\n    top: -26px;\n    right: 0px;\n    color: #fff;\n    border-radius: 20px;\n    display: flex;\n    width: auto;\n    padding: 7px 10px;\n    justify-content: center;\n    align-items: center;\n}\n\n.product-listing.centar_product_listing {\n    min-height: 85vh;\n}\n\n@media screen and (max-width: 768px) {\n    .responsive_button_minus{\n        font-size: 24px !important;\n    }\n}\n\n.table_scroll_container{\n    max-height: 353px;\n    overflow-y: auto;\n    position: relative;\n}\n.table_scroll_container {\n    thead {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n    }\n  \n    &::-webkit-scrollbar {\n      border-radius: 10px;\n      width: 5px;\n      height: 6px;\n    }\n  \n    &::-webkit-scrollbar-track {\n      background: #eeeeee;\n      border-radius: 10px;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background: #818181;\n      border-radius: 10px;\n    }\n  }\n  .infoCircle:hover {\n      font-size: 22px;\n      box-shadow: 1px 1px 5px rgba(17, 17, 17, 0.5);\n      border-radius: 50%;\n  }\n  .btn-add:hover {\n      box-shadow: 1px 1px 5px  var(--newOrangeHover) !important;\n      font-weight: 700;\n      filter: contrast(100%);\n  }\n  .hover_checkout_bar:hover {\n      box-shadow: 1px 1px 8px  var(--newOrangeHover) !important;\n      transition: box-shadow 0.3s ease;\n      font-weight: 700;\n  }\n\n  .termsuse_hover:hover {\n      text-shadow: 2px 2px 4px #0d6dfd77;\n  }\n\n  .trash-icon:hover {\n    color: #000000 !important;\n    transform: scale(1.2);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  .cart_hover:hover{\n    /* color: #000000 !important; */\n    transform: scale(1.05);\n    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */\n  }\n  .button_hover:hover{\n    box-shadow: 1px 1px 8px rgba(17, 17, 17, 0.5) !important;\n    transition: box-shadow 0.3s ease;\n    font-weight: 700;\n    transform: scale(1.01);\n  }\n  .img_hover:hover{\n    transition: box-shadow 0.3s ease;\n    transform: scale(1.01);\n  }\n  .gift_image_container {\n    overflow: hidden;\n    cursor: pointer;\n    border-top-left-radius: 8px;\n  }\n  \n  .gift_image_hover {\n    transition: transform 0.3s ease;\n  }\n  \n  .gift_image_hover:hover {\n    transform: scale(1.05);\n  }\n  .newCustomButton {\n    transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n  .newCustomButton:hover {\n    background-color: var(--newOrangeHover) !important ;\n    border-color: var(--newOrangeHover) !important ;\n}\n  .newCustomSearch {\n    transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n  .newCustomSearch:hover {\n    background-color: var(--newMainBlueHover) !important ;\n    border-color: var(--newMainBlueHover) !important ;\n}\n\n  .newModalHeaderColor{\n    background-color: var(--newMainBlue) !important;\n    color: #fff !important;\n  }\n  .newModalHeaderColor .btn-close {\n    filter: invert(1);\n    opacity: 1;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
